var _metadata, _defs, _g, _g2, _g3, _g4, _g5, _g6, _g7, _g8, _g9, _g10, _g11, _g12, _g13, _g14, _g15, _g16, _g17, _g18, _g19, _g20, _g21, _g22;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgAstronoutSittingNotebook(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlnsDc: "http://purl.org/dc/elements/1.1/",
    xmlnsCc: "http://creativecommons.org/ns#",
    xmlnsRdf: "http://www.w3.org/1999/02/22-rdf-syntax-ns#",
    xmlnsSvg: "http://www.w3.org/2000/svg",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 1333.3333 1333.3333",
    height: 1333.3333,
    width: 1333.3333,
    xmlSpace: "preserve",
    id: "svg2",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _metadata || (_metadata = /*#__PURE__*/React.createElement("metadata", {
    id: "metadata8"
  }, /*#__PURE__*/React.createElement("rdfRDF", null, /*#__PURE__*/React.createElement("ccWork", {
    rdfAbout: ""
  }, /*#__PURE__*/React.createElement("dcformat", null, "image/svg+xml"), /*#__PURE__*/React.createElement("dctype", {
    rdfResource: "http://purl.org/dc/dcmitype/StillImage"
  }))))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", {
    id: "defs6"
  }, /*#__PURE__*/React.createElement("clipPath", {
    id: "clipPath20",
    clipPathUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("path", {
    id: "path18",
    d: "M 0,1000 H 1000 V 0 H 0 Z"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clipPath28",
    clipPathUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("path", {
    id: "path26",
    d: "M 241.539,221.118 H 779.271 V 105.972 H 241.539 Z"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clipPath48",
    clipPathUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("path", {
    id: "path46",
    d: "M 258.346,488.126 H 451.285 V 204.636 H 258.346 Z"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clipPath84",
    clipPathUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("path", {
    id: "path82",
    d: "M 309.605,492.426 H 598.876 V 146.284 H 309.605 Z"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clipPath124",
    clipPathUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("path", {
    id: "path122",
    d: "M 565.589,513.132 H 595.2 v -80.399 h -29.611 z"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clipPath148",
    clipPathUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("path", {
    id: "path146",
    d: "M 377.551,380.222 H 573.534 V 318.386 H 377.551 Z"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clipPath228",
    clipPathUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("path", {
    id: "path226",
    d: "M 398.543,380.222 H 594.526 V 318.386 H 398.543 Z"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clipPath344",
    clipPathUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("path", {
    id: "path342",
    d: "M 668.286,350.236 H 821.6 V 265.27 H 668.286 Z"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clipPath360",
    clipPathUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("path", {
    id: "path358",
    d: "M 503.029,320.305 H 825.203 V 161.016 H 503.029 Z"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clipPath396",
    clipPathUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("path", {
    id: "path394",
    d: "m 538.849,420.78 h 48.338 v -70.545 h -48.338 z"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clipPath412",
    clipPathUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("path", {
    id: "path410",
    d: "m 522.416,451.445 h 88.389 v -53.583 h -88.389 z"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clipPath428",
    clipPathUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("path", {
    id: "path426",
    d: "M 493.607,439.018 H 767.719 V 259.578 H 493.607 Z"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clipPath444",
    clipPathUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("path", {
    id: "path442",
    d: "m 403.855,331.109 h 104.01 v -72.302 h -104.01 z"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clipPath488",
    clipPathUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("path", {
    id: "path486",
    d: "M 262.14,425.799 H 463.935 V 291.66 H 262.14 Z"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clipPath524",
    clipPathUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("path", {
    id: "path522",
    d: "M 323.357,532.592 H 463.083 V 429.029 H 323.357 Z"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clipPath560",
    clipPathUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("path", {
    id: "path558",
    d: "M 311.093,834.081 H 618.319 V 493.663 H 311.093 Z"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clipPath592",
    clipPathUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("path", {
    id: "path590",
    d: "M 405.542,744.259 H 575.767 V 643.589 H 405.542 Z"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clipPath608",
    clipPathUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("path", {
    id: "path606",
    d: "m 629.983,623.246 h 31.996 v -38.887 h -31.996 z"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clipPath624",
    clipPathUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("path", {
    id: "path622",
    d: "m 608.698,581.74 h 19.456 v -20.617 h -19.456 z"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clipPath652",
    clipPathUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("path", {
    id: "path650",
    d: "M 335.078,676.91 H 388.8 v -63.294 h -53.722 z"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clipPath676",
    clipPathUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("path", {
    id: "path674",
    d: "m 302.236,707.267 h 66.152 v -85.028 h -66.152 z"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clipPath736",
    clipPathUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("path", {
    id: "path734",
    d: "M 561.017,312.547 H 714.331 V 227.581 H 561.017 Z"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clipPath752",
    clipPathUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("path", {
    id: "path750",
    d: "M 395.76,282.616 H 717.934 V 123.327 H 395.76 Z"
  })))), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1.3333333,0,0,-1.3333333,0,1333.3333)",
    id: "g10"
  }, /*#__PURE__*/React.createElement("g", {
    id: "g14"
  }, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clipPath20)",
    id: "g16"
  }, /*#__PURE__*/React.createElement("g", {
    id: "g22"
  }, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "g24"
  })), /*#__PURE__*/React.createElement("g", {
    id: "g36"
  }, /*#__PURE__*/React.createElement("g", {
    style: {
      opacity: 0.69999701
    },
    id: "g34",
    clipPath: "url(#clipPath28)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "g32",
    transform: "translate(779.2715,163.5449)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "path30",
    style: {
      fill: "#2d2d2d",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none"
    },
    d: "m 0,0 c 0,-31.796 -120.376,-57.572 -268.866,-57.572 -148.491,0 -268.866,25.776 -268.866,57.572 0,31.797 120.375,57.573 268.866,57.573 C -120.376,57.573 0,31.797 0,0"
  }))))), /*#__PURE__*/React.createElement("g", {
    transform: "translate(332.9409,564.0503)",
    id: "g38"
  }, /*#__PURE__*/React.createElement("path", {
    id: "path40",
    style: {
      fill: "#ffffff",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none"
    },
    d: "m 0,0 c 0,0 -73.049,-13.57 -89.837,-32.901 -16.788,-19.331 2.522,-256.304 32.378,-298.742 29.855,-42.44 153.487,-28.874 153.487,-28.874 0,0 91.724,8.818 94.608,9.157 C 193.52,-351.021 163.616,-4.543 160.982,0 158.349,4.543 43.437,3.808 0,0"
  })), /*#__PURE__*/React.createElement("g", {
    id: "g42"
  }, _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    id: "g44"
  })), /*#__PURE__*/React.createElement("g", {
    id: "g56"
  }, /*#__PURE__*/React.createElement("g", {
    style: {
      opacity: 0.30000299
    },
    id: "g54",
    clipPath: "url(#clipPath48)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "g52",
    transform: "translate(330.9478,205.624)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "path50",
    style: {
      fill: "#2d2d2d",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none"
    },
    d: "m 0,0 c 0,0 -43.077,11.137 -53.251,44.203 -10.174,33.067 -19.84,132.868 -19.332,142.234 0.509,9.365 55.82,8.643 74.576,22.869 18.757,14.225 28.73,65.347 28.73,65.347 0,0 53.889,10.683 75.256,7.122 21.366,-3.561 16.787,-266.796 0,-272.788 C 89.19,2.997 40.533,-3.507 0,0"
  }))))), /*#__PURE__*/React.createElement("g", {
    transform: "translate(332.9409,564.0503)",
    id: "g58"
  }, /*#__PURE__*/React.createElement("path", {
    id: "path60",
    style: {
      fill: "none",
      stroke: "#2d2d2d",
      strokeWidth: 8,
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeMiterlimit: 10,
      strokeDasharray: "none",
      strokeOpacity: 1
    },
    d: "m 0,0 c 0,0 -73.049,-13.57 -89.837,-32.901 -16.788,-19.331 2.522,-256.304 32.378,-298.742 29.855,-42.44 153.487,-28.874 153.487,-28.874 0,0 91.724,8.818 94.608,9.157 C 193.52,-351.021 163.616,-4.543 160.982,0 158.349,4.543 43.437,3.808 0,0 Z"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(336.7041,504.3345)",
    id: "g62"
  }, /*#__PURE__*/React.createElement("path", {
    id: "path64",
    style: {
      fill: "#2d2d2d",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none"
    },
    d: "m 0,0 c -2.606,0.86 -5.485,1.7 -8.269,2.489 -2.814,0.782 -5.649,1.509 -8.494,2.209 -2.85,0.683 -5.714,1.307 -8.583,1.927 -2.882,0.544 -5.761,1.127 -8.661,1.597 -2.891,0.545 -5.812,0.846 -8.722,1.3 -2.921,0.31 -5.845,0.728 -8.783,0.9 -5.883,0.528 -11.737,0.824 -17.813,2.095 l -0.012,0.003 c -0.185,0.039 -0.305,0.221 -0.266,0.406 0.026,0.123 0.115,0.217 0.226,0.255 5.858,2.004 11.974,2.809 18.048,2.798 3.046,0.099 6.082,-0.051 9.132,-0.096 1.52,-0.066 3.039,-0.172 4.559,-0.274 1.522,-0.083 3.037,-0.231 4.553,-0.385 6.069,-0.561 12.106,-1.484 18.077,-2.75 2.989,-0.616 5.957,-1.347 8.912,-2.14 C -3.122,9.503 -0.264,8.637 2.77,7.505 4.839,6.733 5.891,4.43 5.119,2.361 4.366,0.342 2.155,-0.708 0.126,-0.042 Z"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(610.8047,521.5405)",
    id: "g66"
  }, /*#__PURE__*/React.createElement("path", {
    id: "path68",
    style: {
      fill: "#ffffff",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none"
    },
    d: "m 0,0 c 0,0 17.59,1.631 37.688,-67.055 20.097,-68.687 8.29,-112.532 0,-115.384 -8.29,-2.852 -42.354,8.288 -42.354,10.202 0,1.914 -15.709,138.139 -18.951,159.575 C -26.859,8.774 0,0 0,0"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(610.8047,521.5405)",
    id: "g70"
  }, /*#__PURE__*/React.createElement("path", {
    id: "path72",
    style: {
      fill: "none",
      stroke: "#2d2d2d",
      strokeWidth: 8,
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeMiterlimit: 10,
      strokeDasharray: "none",
      strokeOpacity: 1
    },
    d: "m 0,0 c 0,0 17.59,1.631 37.688,-67.055 20.097,-68.687 8.29,-112.532 0,-115.384 -8.29,-2.852 -42.354,8.288 -42.354,10.202 0,1.914 -15.709,138.139 -18.951,159.575 C -26.859,8.774 0,0 0,0 Z"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(365.6899,561.2344)",
    id: "g74"
  }, /*#__PURE__*/React.createElement("path", {
    id: "path76",
    style: {
      fill: "#ffffff",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none"
    },
    d: "m 0,0 c 0,0 -107.943,-263.132 -24.328,-362.97 37.772,-45.099 66.054,-57.628 125.957,-50.347 18.293,2.222 38.364,1.003 55.133,4.762 32.845,7.363 57.944,23.794 66.655,52.354 24,78.685 0,320.809 0,320.809 0,0 -165.801,92.926 -223.417,35.392"
  })), /*#__PURE__*/React.createElement("g", {
    id: "g78"
  }, _g3 || (_g3 = /*#__PURE__*/React.createElement("g", {
    id: "g80"
  })), /*#__PURE__*/React.createElement("g", {
    id: "g92"
  }, /*#__PURE__*/React.createElement("g", {
    style: {
      opacity: 0.30000299
    },
    id: "g90",
    clipPath: "url(#clipPath84)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "g88",
    transform: "translate(395.7598,313.4453)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "path86",
    style: {
      fill: "#2d2d2d",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none"
    },
    d: "m 0,0 c -37.069,44.261 -66.145,107.688 -54.012,178.981 -26.003,-85.052 -56.812,-226.788 -0.385,-294.162 22.588,-26.971 40.639,-44.745 67.139,-50.664 14.811,-3.307 32.478,0.734 54.529,0.134 60.742,-1.652 112.183,11.751 126.076,57.299 5.454,17.883 8.428,44.208 9.769,74.212 C 137.829,-50.937 72.699,-86.804 0,0"
  }))))), /*#__PURE__*/React.createElement("g", {
    transform: "translate(365.6899,561.2344)",
    id: "g94"
  }, /*#__PURE__*/React.createElement("path", {
    id: "path96",
    style: {
      fill: "none",
      stroke: "#2d2d2d",
      strokeWidth: 8,
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeMiterlimit: 10,
      strokeDasharray: "none",
      strokeOpacity: 1
    },
    d: "m 0,0 c 0,0 -110.798,-265.594 -24.328,-362.97 60.893,-68.572 87.076,-50.193 131.997,-50.25 54.522,-0.067 102.588,27.581 115.748,70.722 24,78.686 0,307.106 0,307.106 0,0 -165.801,92.926 -223.417,35.392 z"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(610.4297,447.9482)",
    id: "g98"
  }, /*#__PURE__*/React.createElement("path", {
    id: "path100",
    style: {
      fill: "#777777",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none"
    },
    d: "M 0,0 V 0 L -27.676,-0.327 Z"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(610.4297,447.9482)",
    id: "g102"
  }, /*#__PURE__*/React.createElement("path", {
    id: "path104",
    style: {
      fill: "#00c7be",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none"
    },
    d: "m 0,0 c 0.527,-5.262 0.775,-10.714 0.65,-16.314 l -27.015,0.062 c 0,0 -0.205,6.481 -1.311,15.925 z"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(588.6221,513.1313)",
    id: "g106"
  }, /*#__PURE__*/React.createElement("path", {
    id: "path108",
    style: {
      fill: "#777777",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none"
    },
    d: "M 0,0 C 0,0 18.053,-27.661 21.808,-65.183 L -5.868,-65.51 c -2.025,17.3 -7.078,44.579 -19.491,60.448 z"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(610.4326,447.9482)",
    id: "g110"
  }, /*#__PURE__*/React.createElement("path", {
    id: "path112",
    style: {
      fill: "none",
      stroke: "#2d2d2d",
      strokeWidth: 5,
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeMiterlimit: 10,
      strokeDasharray: "none",
      strokeOpacity: 1
    },
    d: "M 0,0 -27.679,-0.327"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(596.748,497.71)",
    id: "g114"
  }, /*#__PURE__*/React.createElement("path", {
    id: "path116",
    style: {
      fill: "none",
      stroke: "#2d2d2d",
      strokeWidth: 5,
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeMiterlimit: 10,
      strokeDasharray: "none",
      strokeOpacity: 1
    },
    d: "M 0,0 -25.316,-3.748"
  })), /*#__PURE__*/React.createElement("g", {
    id: "g118"
  }, _g4 || (_g4 = /*#__PURE__*/React.createElement("g", {
    id: "g120"
  })), /*#__PURE__*/React.createElement("g", {
    id: "g132"
  }, /*#__PURE__*/React.createElement("g", {
    style: {
      opacity: 0.30000299
    },
    id: "g130",
    clipPath: "url(#clipPath124)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "g128",
    transform: "translate(595.2002,433.21)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "path126",
    style: {
      fill: "#2d2d2d",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none"
    },
    d: "m 0,0 c -0.322,0.578 -2.146,45.385 -12.905,62.73 l 7.987,0.813 1.659,1.236 c 0,0 -0.133,4.093 0.448,4.689 0.581,0.595 -3.767,10.453 -3.767,10.453 l -23.033,-4.709 0.881,-3.42 c 0,0 6.602,-13.455 11.866,-32.122 5.262,-18.668 5.828,-40.147 5.828,-40.147 z"
  }))))), /*#__PURE__*/React.createElement("g", {
    transform: "translate(584.0645,431.6963)",
    id: "g134"
  }, /*#__PURE__*/React.createElement("path", {
    id: "path136",
    style: {
      fill: "none",
      stroke: "#2d2d2d",
      strokeWidth: 7,
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeMiterlimit: 10,
      strokeDasharray: "none",
      strokeOpacity: 1
    },
    d: "m 0,0 c 0,0 -1.611,51.841 -20.802,76.373 l 25.36,5.062 c 0,0 23.474,-35.958 22.458,-81.497 z"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(539.8447,318.3857)",
    id: "g138"
  }, /*#__PURE__*/React.createElement("path", {
    id: "path140",
    style: {
      fill: "#ffffff",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none"
    },
    d: "m 0,0 h -128.605 c -18.606,0 -33.688,15.083 -33.688,33.688 v 44.549 c 0,18.606 15.082,33.689 33.688,33.689 H 0 c 18.606,0 33.688,-15.083 33.688,-33.689 V 33.688 C 33.688,15.083 18.606,0 0,0"
  })), /*#__PURE__*/React.createElement("g", {
    id: "g142"
  }, _g5 || (_g5 = /*#__PURE__*/React.createElement("g", {
    id: "g144"
  })), /*#__PURE__*/React.createElement("g", {
    id: "g156"
  }, /*#__PURE__*/React.createElement("g", {
    style: {
      opacity: 0.30000299
    },
    id: "g154",
    clipPath: "url(#clipPath148)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "g152",
    transform: "translate(543.835,342.0078)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "path150",
    style: {
      fill: "#2d2d2d",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none"
    },
    d: "m 0,0 h -136.585 c -16.402,0 -29.699,17.109 -29.699,38.214 V 14.592 c 0,-21.105 13.297,-38.214 29.699,-38.214 H 0 c 16.402,0 29.698,17.109 29.698,38.214 V 38.214 C 29.698,17.109 16.402,0 0,0"
  }))))), /*#__PURE__*/React.createElement("g", {
    transform: "translate(539.8447,318.3857)",
    id: "g158"
  }, /*#__PURE__*/React.createElement("path", {
    id: "path160",
    style: {
      fill: "none",
      stroke: "#2d2d2d",
      strokeWidth: 8,
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeMiterlimit: 10,
      strokeDasharray: "none",
      strokeOpacity: 1
    },
    d: "m 0,0 h -128.605 c -18.606,0 -33.688,15.083 -33.688,33.688 v 44.549 c 0,18.606 15.082,33.689 33.688,33.689 H 0 c 18.606,0 33.688,-15.083 33.688,-33.689 V 33.688 C 33.688,15.083 18.606,0 0,0 Z"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(533.2324,366.4053)",
    id: "g162"
  }, /*#__PURE__*/React.createElement("path", {
    id: "path164",
    style: {
      fill: "#ff546a",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none"
    },
    d: "m 0,0 h -23.208 c -6.234,0 -11.289,5.054 -11.289,11.288 v 17.504 c 0,6.234 5.055,11.288 11.289,11.288 H 0 c 6.234,0 11.288,-5.054 11.288,-11.288 V 11.288 C 11.288,5.054 6.234,0 0,0"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(533.2324,366.4053)",
    id: "g166"
  }, /*#__PURE__*/React.createElement("path", {
    id: "path168",
    style: {
      fill: "none",
      stroke: "#2d2d2d",
      strokeWidth: 5,
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeMiterlimit: 10,
      strokeDasharray: "none",
      strokeOpacity: 1
    },
    d: "m 0,0 h -23.208 c -6.234,0 -11.289,5.054 -11.289,11.288 v 17.504 c 0,6.234 5.055,11.288 11.289,11.288 H 0 c 6.234,0 11.288,-5.054 11.288,-11.288 V 11.288 C 11.288,5.054 6.234,0 0,0 Z"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(530.6875,395.502)",
    id: "g170"
  }, /*#__PURE__*/React.createElement("path", {
    id: "path172",
    style: {
      fill: "#ffffff",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none"
    },
    d: "m 0,0 c -5.936,5.013 -9.06,-3.249 -9.06,-3.249 0,0 -3.124,8.262 -9.059,3.249 -5.51,-4.652 0.825,-11.188 4.39,-13.736 1.55,-1.109 4.669,-5.784 4.669,-5.784 0,0 3.12,4.675 4.669,5.784 C -0.825,-11.188 5.51,-4.652 0,0"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(438.77,401.7246)",
    id: "g174"
  }, /*#__PURE__*/React.createElement("path", {
    id: "path176",
    style: {
      fill: "#2d2d2d",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none"
    },
    d: "m 0,0 v 0 c 0,-4.348 2.739,-7.872 6.117,-7.872 h 19.326 c 3.379,0 6.118,3.524 6.118,7.872 0,4.347 -2.739,7.871 -6.118,7.871 H 6.117 C 2.739,7.871 0,4.347 0,0"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(440.522,366.4775)",
    id: "g178"
  }, /*#__PURE__*/React.createElement("path", {
    id: "path180",
    style: {
      fill: "#2d2d2d",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none"
    },
    d: "m 0,0 h 23.691 c 3.379,0 6.118,3.523 6.118,7.871 0,4.348 -2.739,7.872 -6.118,7.872 H 0 c -3.379,0 -6.118,-3.524 -6.118,-7.872 C -6.118,3.523 -3.379,0 0,0"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(422.1294,339.1016)",
    id: "g182"
  }, /*#__PURE__*/React.createElement("path", {
    id: "path184",
    style: {
      fill: "#2d2d2d",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none"
    },
    d: "m 0,0 h 42.084 c 3.378,0 6.117,3.524 6.117,7.872 0,4.347 -2.739,7.871 -6.117,7.871 H 0 c -3.379,0 -6.118,-3.524 -6.118,-7.871 C -6.118,3.524 -3.379,0 0,0"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(398.4775,401.9492)",
    id: "g186"
  }, /*#__PURE__*/React.createElement("path", {
    id: "path188",
    style: {
      fill: "#ff546a",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none"
    },
    d: "m 0,0 v -0.45 c 0,-3.217 2.027,-5.825 4.527,-5.825 h 47.77 c 2.5,0 4.527,2.608 4.527,5.825 V 0 c 0,3.217 -2.027,5.825 -4.527,5.825 H 4.527 C 2.027,5.825 0,3.217 0,0"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(398.4775,374.3965)",
    id: "g190"
  }, /*#__PURE__*/React.createElement("path", {
    id: "path192",
    style: {
      fill: "#ff546a",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none"
    },
    d: "m 0,0 v -0.096 c 0,-3.217 2.027,-5.825 4.527,-5.825 h 55.499 c 2.5,0 4.527,2.608 4.527,5.825 V 0 c 0,3.218 -2.027,5.825 -4.527,5.825 H 4.527 C 2.027,5.825 0,3.218 0,0"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(398.4775,346.9736)",
    id: "g194"
  }, /*#__PURE__*/React.createElement("path", {
    id: "path196",
    style: {
      fill: "#ff546a",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none"
    },
    d: "m 0,0 v 0 c 0,-3.218 2.027,-5.825 4.527,-5.825 h 31.238 c 2.501,0 4.527,2.607 4.527,5.825 0,3.217 -2.026,5.825 -4.527,5.825 H 4.527 C 2.027,5.825 0,3.217 0,0"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(463.3916,393.8525)",
    id: "g198"
  }, /*#__PURE__*/React.createElement("path", {
    id: "path200",
    style: {
      fill: "none",
      stroke: "#2d2d2d",
      strokeWidth: 4,
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeMiterlimit: 10,
      strokeDasharray: "none",
      strokeOpacity: 1
    },
    d: "m 0,0 h -57.975 c -3.832,0 -6.939,3.106 -6.939,6.939 v 1.865 c 0,3.833 3.107,6.939 6.939,6.939 H 0 c 3.833,0 6.939,-3.106 6.939,-6.939 V 6.939 C 6.939,3.106 3.833,0 0,0 Z"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(463.3916,366.4775)",
    id: "g202"
  }, /*#__PURE__*/React.createElement("path", {
    id: "path204",
    style: {
      fill: "none",
      stroke: "#2d2d2d",
      strokeWidth: 4,
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeMiterlimit: 10,
      strokeDasharray: "none",
      strokeOpacity: 1
    },
    d: "m 0,0 h -57.975 c -3.832,0 -6.939,3.106 -6.939,6.939 v 1.865 c 0,3.832 3.107,6.939 6.939,6.939 H 0 c 3.833,0 6.939,-3.107 6.939,-6.939 V 6.939 C 6.939,3.106 3.833,0 0,0 Z"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(463.3916,339.1016)",
    id: "g206"
  }, /*#__PURE__*/React.createElement("path", {
    id: "path208",
    style: {
      fill: "none",
      stroke: "#2d2d2d",
      strokeWidth: 4,
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeMiterlimit: 10,
      strokeDasharray: "none",
      strokeOpacity: 1
    },
    d: "m 0,0 h -57.975 c -3.832,0 -6.939,3.107 -6.939,6.939 v 1.865 c 0,3.833 3.107,6.939 6.939,6.939 H 0 c 3.833,0 6.939,-3.106 6.939,-6.939 V 6.939 C 6.939,3.107 3.833,0 0,0 Z"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(521.6279,406.4854)",
    id: "g210"
  }, /*#__PURE__*/React.createElement("path", {
    id: "path212",
    style: {
      fill: "none",
      stroke: "#2d2d2d",
      strokeWidth: 5,
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeMiterlimit: 10,
      strokeDasharray: "none",
      strokeOpacity: 1
    },
    d: "M 0,0 V 23.942"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(521.6279,366.4053)",
    id: "g214"
  }, /*#__PURE__*/React.createElement("path", {
    id: "path216",
    style: {
      fill: "none",
      stroke: "#2d2d2d",
      strokeWidth: 5,
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeMiterlimit: 10,
      strokeDasharray: "none",
      strokeOpacity: 1
    },
    d: "M 0,0 V -48.02"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(560.8369,318.3857)",
    id: "g218"
  }, /*#__PURE__*/React.createElement("path", {
    id: "path220",
    style: {
      fill: "#ffffff",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none"
    },
    d: "m 0,0 h -128.605 c -18.606,0 -33.689,15.083 -33.689,33.688 v 44.549 c 0,18.606 15.083,33.689 33.689,33.689 H 0 c 18.605,0 33.688,-15.083 33.688,-33.689 V 33.688 C 33.688,15.083 18.605,0 0,0"
  })), /*#__PURE__*/React.createElement("g", {
    id: "g222"
  }, _g6 || (_g6 = /*#__PURE__*/React.createElement("g", {
    id: "g224"
  })), /*#__PURE__*/React.createElement("g", {
    id: "g236"
  }, /*#__PURE__*/React.createElement("g", {
    style: {
      opacity: 0.30000299
    },
    id: "g234",
    clipPath: "url(#clipPath228)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "g232",
    transform: "translate(564.8271,342.0078)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "path230",
    style: {
      fill: "#2d2d2d",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none"
    },
    d: "m 0,0 h -136.585 c -16.403,0 -29.699,17.109 -29.699,38.214 V 14.592 c 0,-21.105 13.296,-38.214 29.699,-38.214 H 0 c 16.401,0 29.698,17.109 29.698,38.214 V 38.214 C 29.698,17.109 16.401,0 0,0"
  }))))), /*#__PURE__*/React.createElement("g", {
    transform: "translate(560.8369,318.3857)",
    id: "g238"
  }, /*#__PURE__*/React.createElement("path", {
    id: "path240",
    style: {
      fill: "none",
      stroke: "#2d2d2d",
      strokeWidth: 8,
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeMiterlimit: 10,
      strokeDasharray: "none",
      strokeOpacity: 1
    },
    d: "m 0,0 h -128.605 c -18.606,0 -33.689,15.083 -33.689,33.688 v 44.549 c 0,18.606 15.083,33.689 33.689,33.689 H 0 c 18.605,0 33.688,-15.083 33.688,-33.689 V 33.688 C 33.688,15.083 18.605,0 0,0 Z"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(554.2236,366.4053)",
    id: "g242"
  }, /*#__PURE__*/React.createElement("path", {
    id: "path244",
    style: {
      fill: "#ff546a",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none"
    },
    d: "m 0,0 h -23.208 c -6.233,0 -11.288,5.054 -11.288,11.288 v 17.504 c 0,6.234 5.055,11.288 11.288,11.288 H 0 c 6.234,0 11.288,-5.054 11.288,-11.288 V 11.288 C 11.288,5.054 6.234,0 0,0"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(554.2236,366.4053)",
    id: "g246"
  }, /*#__PURE__*/React.createElement("path", {
    id: "path248",
    style: {
      fill: "none",
      stroke: "#2d2d2d",
      strokeWidth: 5,
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeMiterlimit: 10,
      strokeDasharray: "none",
      strokeOpacity: 1
    },
    d: "m 0,0 h -23.208 c -6.233,0 -11.288,5.054 -11.288,11.288 v 17.504 c 0,6.234 5.055,11.288 11.288,11.288 H 0 c 6.234,0 11.288,-5.054 11.288,-11.288 V 11.288 C 11.288,5.054 6.234,0 0,0 Z"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(551.6797,395.502)",
    id: "g250"
  }, /*#__PURE__*/React.createElement("path", {
    id: "path252",
    style: {
      fill: "#ffffff",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none"
    },
    d: "m 0,0 c -5.936,5.013 -9.06,-3.249 -9.06,-3.249 0,0 -3.124,8.262 -9.059,3.249 -5.51,-4.652 0.825,-11.188 4.39,-13.736 1.55,-1.109 4.669,-5.784 4.669,-5.784 0,0 3.12,4.675 4.669,5.784 C -0.825,-11.188 5.51,-4.652 0,0"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(459.7617,401.7246)",
    id: "g254"
  }, /*#__PURE__*/React.createElement("path", {
    id: "path256",
    style: {
      fill: "#2d2d2d",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none"
    },
    d: "m 0,0 v 0 c 0,-4.348 2.739,-7.872 6.118,-7.872 h 19.325 c 3.379,0 6.118,3.524 6.118,7.872 0,4.347 -2.739,7.871 -6.118,7.871 H 6.118 C 2.739,7.871 0,4.347 0,0"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(461.5137,366.4775)",
    id: "g258"
  }, /*#__PURE__*/React.createElement("path", {
    id: "path260",
    style: {
      fill: "#2d2d2d",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none"
    },
    d: "m 0,0 h 23.691 c 3.379,0 6.118,3.523 6.118,7.871 0,4.348 -2.739,7.872 -6.118,7.872 H 0 c -3.378,0 -6.117,-3.524 -6.117,-7.872 C -6.117,3.523 -3.378,0 0,0"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(443.1211,339.1016)",
    id: "g262"
  }, /*#__PURE__*/React.createElement("path", {
    id: "path264",
    style: {
      fill: "#2d2d2d",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none"
    },
    d: "m 0,0 h 42.084 c 3.379,0 6.118,3.524 6.118,7.872 0,4.347 -2.739,7.871 -6.118,7.871 H 0 c -3.378,0 -6.118,-3.524 -6.118,-7.871 C -6.118,3.524 -3.378,0 0,0"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(419.4697,401.9492)",
    id: "g266"
  }, /*#__PURE__*/React.createElement("path", {
    id: "path268",
    style: {
      fill: "#ff546a",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none"
    },
    d: "m 0,0 v -0.45 c 0,-3.217 2.027,-5.825 4.527,-5.825 h 47.77 c 2.5,0 4.527,2.608 4.527,5.825 V 0 c 0,3.217 -2.027,5.825 -4.527,5.825 H 4.527 C 2.027,5.825 0,3.217 0,0"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(419.4697,374.3965)",
    id: "g270"
  }, /*#__PURE__*/React.createElement("path", {
    id: "path272",
    style: {
      fill: "#ff546a",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none"
    },
    d: "m 0,0 v -0.096 c 0,-3.217 2.027,-5.825 4.527,-5.825 h 55.499 c 2.5,0 4.527,2.608 4.527,5.825 V 0 c 0,3.218 -2.027,5.825 -4.527,5.825 H 4.527 C 2.027,5.825 0,3.218 0,0"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(419.4697,346.9736)",
    id: "g274"
  }, /*#__PURE__*/React.createElement("path", {
    id: "path276",
    style: {
      fill: "#ff546a",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none"
    },
    d: "m 0,0 v 0 c 0,-3.218 2.027,-5.825 4.527,-5.825 h 31.238 c 2.5,0 4.527,2.607 4.527,5.825 0,3.217 -2.027,5.825 -4.527,5.825 H 4.527 C 2.027,5.825 0,3.217 0,0"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(484.3833,393.8525)",
    id: "g278"
  }, /*#__PURE__*/React.createElement("path", {
    id: "path280",
    style: {
      fill: "none",
      stroke: "#2d2d2d",
      strokeWidth: 4,
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeMiterlimit: 10,
      strokeDasharray: "none",
      strokeOpacity: 1
    },
    d: "m 0,0 h -57.974 c -3.833,0 -6.94,3.106 -6.94,6.939 v 1.865 c 0,3.833 3.107,6.939 6.94,6.939 H 0 c 3.833,0 6.939,-3.106 6.939,-6.939 V 6.939 C 6.939,3.106 3.833,0 0,0 Z"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(484.3833,366.4775)",
    id: "g282"
  }, /*#__PURE__*/React.createElement("path", {
    id: "path284",
    style: {
      fill: "none",
      stroke: "#2d2d2d",
      strokeWidth: 4,
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeMiterlimit: 10,
      strokeDasharray: "none",
      strokeOpacity: 1
    },
    d: "m 0,0 h -57.974 c -3.833,0 -6.94,3.106 -6.94,6.939 v 1.865 c 0,3.832 3.107,6.939 6.94,6.939 H 0 c 3.833,0 6.939,-3.107 6.939,-6.939 V 6.939 C 6.939,3.106 3.833,0 0,0 Z"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(484.3833,339.1016)",
    id: "g286"
  }, /*#__PURE__*/React.createElement("path", {
    id: "path288",
    style: {
      fill: "none",
      stroke: "#2d2d2d",
      strokeWidth: 4,
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeMiterlimit: 10,
      strokeDasharray: "none",
      strokeOpacity: 1
    },
    d: "m 0,0 h -57.974 c -3.833,0 -6.94,3.107 -6.94,6.939 v 1.865 c 0,3.833 3.107,6.939 6.94,6.939 H 0 c 3.833,0 6.939,-3.106 6.939,-6.939 V 6.939 C 6.939,3.107 3.833,0 0,0 Z"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(542.6201,406.4854)",
    id: "g290"
  }, /*#__PURE__*/React.createElement("path", {
    id: "path292",
    style: {
      fill: "none",
      stroke: "#2d2d2d",
      strokeWidth: 5,
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeMiterlimit: 10,
      strokeDasharray: "none",
      strokeOpacity: 1
    },
    d: "M 0,0 V 23.942"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(542.6201,366.4053)",
    id: "g294"
  }, /*#__PURE__*/React.createElement("path", {
    id: "path296",
    style: {
      fill: "none",
      stroke: "#2d2d2d",
      strokeWidth: 5,
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeMiterlimit: 10,
      strokeDasharray: "none",
      strokeOpacity: 1
    },
    d: "M 0,0 V -48.02"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(665.2578,340.4326)",
    id: "g298"
  }, /*#__PURE__*/React.createElement("path", {
    id: "path300",
    style: {
      fill: "#ffffff",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none"
    },
    d: "M 0,0 C -0.693,-0.567 -1.399,-1.156 -2.115,-1.768 -1.399,-1.156 -0.693,-0.567 0,0"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(658.7471,334.7295)",
    id: "g302"
  }, /*#__PURE__*/React.createElement("path", {
    id: "path304",
    style: {
      fill: "#ffffff",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none"
    },
    d: "M 0,0 C -1.119,-1.05 -2.249,-2.149 -3.384,-3.299 -2.249,-2.149 -1.119,-1.05 0,0"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(660.9678,336.7637)",
    id: "g306"
  }, /*#__PURE__*/React.createElement("path", {
    id: "path308",
    style: {
      fill: "#ffffff",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none"
    },
    d: "M 0,0 C -0.733,-0.656 -1.475,-1.334 -2.221,-2.034 -1.475,-1.334 -0.733,-0.656 0,0"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(670.1865,344.2676)",
    id: "g310"
  }, /*#__PURE__*/React.createElement("path", {
    id: "path312",
    style: {
      fill: "#ffffff",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none"
    },
    d: "M 0,0 C -0.616,-0.455 -1.25,-0.933 -1.9,-1.434 -1.25,-0.933 -0.616,-0.455 0,0"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(676.5283,348.6523)",
    id: "g314"
  }, /*#__PURE__*/React.createElement("path", {
    id: "path316",
    style: {
      fill: "#ffffff",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none"
    },
    d: "M 0,0 C -0.428,-0.275 -0.885,-0.573 -1.367,-0.893 -0.885,-0.573 -0.428,-0.275 0,0"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(628.6123,282.3857)",
    id: "g318"
  }, /*#__PURE__*/React.createElement("path", {
    id: "path320",
    style: {
      fill: "#00c7be",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none"
    },
    d: "m 0,0 c 3.121,17.607 11.743,31.949 21.093,42.89 1.496,1.751 3.01,3.415 4.523,4.99 0.379,0.394 0.757,0.782 1.135,1.165 1.135,1.149 2.265,2.249 3.384,3.299 0.746,0.7 1.487,1.378 2.22,2.034 0.734,0.655 1.459,1.29 2.175,1.901 0.716,0.612 1.422,1.2 2.116,1.768 1.04,0.85 2.052,1.651 3.028,2.401 0.65,0.501 1.284,0.979 1.9,1.434 1.848,1.366 3.528,2.531 4.975,3.492 0.482,0.319 0.939,0.617 1.367,0.893 2.569,1.649 4.117,2.481 4.117,2.481 43.794,-18.113 66.363,-74.169 66.363,-74.169 0,0 33.378,32.524 65.045,11.983 31.667,-20.541 10.271,-106.128 -37.658,-124.101 -47.929,-17.974 -133.537,33.133 -133.537,33.133 0,0 -14.404,28 -14.108,63.826 C -1.807,-13.945 -1.248,-7.043 0,0"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(654.2285,330.2656)",
    id: "g322"
  }, /*#__PURE__*/React.createElement("path", {
    id: "path324",
    style: {
      fill: "#ffffff",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none"
    },
    d: "M 0,0 C -1.514,-1.575 -3.027,-3.239 -4.523,-4.99 -3.027,-3.239 -1.514,-1.575 0,0"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(626.75,261.8057)",
    id: "g326"
  }, /*#__PURE__*/React.createElement("path", {
    id: "path328",
    style: {
      fill: "#ffffff",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none"
    },
    d: "M 0,0 C -0.296,-35.826 14.108,-63.826 14.108,-63.826 14.107,-63.825 -0.296,-35.825 0,0"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(503.0293,191.2715)",
    id: "g330"
  }, /*#__PURE__*/React.createElement("path", {
    id: "path332",
    style: {
      fill: "#ffffff",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none"
    },
    d: "m 0,0 39.61,122.068 c 0,0 75.132,53.492 126.485,41.51 3.991,-0.932 7.831,-2.189 11.521,-3.716 0,0 -1.548,-0.832 -4.117,-2.481 -0.428,-0.276 -0.885,-0.573 -1.367,-0.893 -1.447,-0.961 -3.127,-2.126 -4.975,-3.492 -0.616,-0.455 -1.25,-0.933 -1.9,-1.434 -0.976,-0.75 -1.988,-1.55 -3.028,-2.401 -0.694,-0.567 -1.4,-1.156 -2.116,-1.767 -0.716,-0.612 -1.441,-1.247 -2.175,-1.902 -0.733,-0.656 -1.474,-1.334 -2.22,-2.034 -1.119,-1.05 -2.249,-2.149 -3.384,-3.299 -0.378,-0.383 -0.756,-0.77 -1.135,-1.165 -1.513,-1.575 -3.027,-3.239 -4.523,-4.99 -9.35,-10.941 -17.972,-25.282 -21.093,-42.89 -1.248,-7.043 -1.807,-13.945 -1.862,-20.58 C 123.425,34.709 137.828,6.709 137.829,6.708 137.828,6.708 57.286,-32.63 0,0"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(626.75,261.8057)",
    id: "g334"
  }, /*#__PURE__*/React.createElement("path", {
    id: "path336",
    style: {
      fill: "#ffffff",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none"
    },
    d: "M 0,0 C 0.056,6.635 0.614,13.537 1.862,20.58 4.983,38.188 13.605,52.529 22.955,63.47 13.605,52.529 4.983,38.188 1.862,20.58 0.614,13.537 0.056,6.635 0,0"
  })), /*#__PURE__*/React.createElement("g", {
    id: "g338"
  }, _g7 || (_g7 = /*#__PURE__*/React.createElement("g", {
    id: "g340"
  })), /*#__PURE__*/React.createElement("g", {
    id: "g352"
  }, /*#__PURE__*/React.createElement("g", {
    style: {
      opacity: 0.39999402
    },
    id: "g350",
    clipPath: "url(#clipPath344)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "g348",
    transform: "translate(804.3506,280.3887)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "path346",
    style: {
      fill: "#ffffff",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none"
    },
    d: "m 0,0 c 0,0 -17.83,6.704 -35.09,0.855 -17.261,-5.847 -30.241,-15.974 -30.241,-15.974 l 1.537,2.514 c 0,0 -34.31,62.465 -72.27,75.05 l 8.242,5.819 6.204,1.583 c 0,0 17.631,-9.814 31.967,-24.96 14.335,-15.146 32.308,-44.673 32.308,-44.673 0,0 2.14,-0.856 3.21,-0.214 1.07,0.642 12.624,11.769 34.876,14.978 22.253,3.209 33.219,-12.115 33.219,-12.115 0,0 3.897,-4.043 3.206,-4.843 C 16.476,-2.781 13.48,-4.493 13.48,-4.493 L 6.419,-1.98 Z"
  }))))), /*#__PURE__*/React.createElement("g", {
    id: "g354"
  }, _g8 || (_g8 = /*#__PURE__*/React.createElement("g", {
    id: "g356"
  })), /*#__PURE__*/React.createElement("g", {
    id: "g368"
  }, /*#__PURE__*/React.createElement("g", {
    style: {
      opacity: 0.30000299
    },
    id: "g366",
    clipPath: "url(#clipPath360)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "g364",
    transform: "translate(774.3955,164.8467)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "path362",
    style: {
      fill: "#2d2d2d",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none"
    },
    d: "m 0,0 c -47.929,-17.974 -133.537,33.133 -133.537,33.133 -0.001,0 -80.543,-39.338 -137.829,-6.708 l 39.61,122.068 c 0,0 3.933,2.798 10.6,6.965 -31.154,-47.382 36.289,-50.614 69.239,-52.843 32.951,-2.228 102.705,-72.232 124.529,-34.574 21.825,37.658 39.893,38.083 39.893,38.083 C 0.403,96.92 -4.554,84.642 -4.554,84.642 c 0,0 14.06,18.848 34.509,17.973 C 50.287,101.745 50.802,70.426 50.808,70.063 45.165,41.016 26.704,10.014 0,0"
  }))))), /*#__PURE__*/React.createElement("g", {
    transform: "translate(531.9561,309.3096)",
    id: "g370"
  }, /*#__PURE__*/React.createElement("path", {
    id: "path372",
    style: {
      fill: "#2d2d2d",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none"
    },
    d: "m 0,0 c 4.394,3.354 8.864,6.479 13.452,9.486 2.287,1.506 4.591,2.99 6.909,4.45 2.327,1.445 4.683,2.846 7.044,4.237 9.437,5.584 19.186,10.654 29.176,15.269 10,4.589 20.262,8.722 30.902,11.926 10.655,3.109 21.694,5.414 33.091,5.695 5.688,0.142 11.47,-0.302 17.171,-1.559 5.608,-1.29 11.047,-3.187 16.205,-5.638 10.347,-4.869 19.529,-11.748 27.584,-19.545 8.073,-7.812 15.066,-16.583 21.243,-25.822 3.086,-4.626 5.965,-9.38 8.64,-14.248 1.338,-2.435 2.624,-4.897 3.855,-7.395 1.237,-2.521 2.395,-4.971 3.527,-7.692 l -6.567,1.385 c 0.833,0.795 1.533,1.403 2.308,2.066 0.759,0.646 1.526,1.272 2.303,1.883 1.553,1.223 3.141,2.389 4.769,3.503 3.256,2.226 6.663,4.243 10.23,6.001 7.117,3.495 14.956,6.001 23.189,6.429 4.102,0.217 8.273,-0.102 12.32,-1.019 4.046,-0.912 7.957,-2.405 11.575,-4.359 1.805,-0.992 3.516,-2.027 5.304,-3.371 1.742,-1.315 3.291,-2.85 4.695,-4.476 1.41,-1.627 2.619,-3.393 3.67,-5.218 1.063,-1.821 1.956,-3.715 2.699,-5.64 2.998,-7.727 3.905,-15.81 3.845,-23.694 -0.098,-7.904 -1.217,-15.695 -3.077,-23.27 -1.861,-7.576 -4.446,-14.956 -7.734,-22.026 -3.287,-7.067 -7.258,-13.841 -11.988,-20.114 -4.739,-6.257 -10.267,-12.012 -16.653,-16.812 -6.394,-4.752 -13.7,-8.57 -21.58,-10.56 -7.821,-2.017 -15.81,-2.527 -23.619,-2.194 -7.822,0.335 -15.511,1.48 -23.049,3.085 -15.078,3.246 -29.577,8.263 -43.65,14.105 -7.035,2.933 -13.966,6.09 -20.795,9.45 -6.848,3.377 -13.521,6.882 -20.216,10.794 l 3.911,-0.18 c -2.91,-1.353 -5.669,-2.493 -8.529,-3.632 -2.84,-1.126 -5.698,-2.189 -8.573,-3.202 -5.749,-2.025 -11.57,-3.835 -17.453,-5.436 -11.765,-3.192 -23.797,-5.531 -36.007,-6.688 -12.2,-1.145 -24.612,-1.088 -36.871,0.834 -12.236,1.907 -24.331,5.771 -35.23,12.003 -1.919,1.093 -2.588,3.537 -1.493,5.456 1.094,1.919 3.533,2.588 5.452,1.495 9.955,-5.664 21.078,-9.218 32.515,-10.98 11.45,-1.773 23.204,-1.82 34.858,-0.701 11.663,1.128 23.251,3.398 34.615,6.508 5.681,1.557 11.312,3.321 16.867,5.289 2.776,0.985 5.536,2.018 8.265,3.106 2.708,1.082 5.487,2.245 8.01,3.424 1.291,0.604 2.733,0.496 3.881,-0.163 l 0.03,-0.017 c 6.313,-3.676 12.989,-7.159 19.64,-10.451 6.679,-3.292 13.455,-6.384 20.316,-9.25 13.72,-5.71 27.808,-10.578 42.186,-13.68 7.183,-1.535 14.44,-2.612 21.668,-2.926 7.217,-0.317 14.423,0.177 21.199,1.921 6.747,1.694 13.054,4.971 18.733,9.175 5.66,4.25 10.68,9.443 15.031,15.178 8.661,11.524 14.845,25.059 18.326,39.136 1.736,7.042 2.765,14.254 2.856,21.411 0.073,7.134 -0.795,14.291 -3.268,20.638 -0.609,1.586 -1.328,3.108 -2.164,4.537 -0.824,1.437 -1.753,2.792 -2.811,4.009 -1.054,1.218 -2.189,2.353 -3.458,3.306 -1.218,0.922 -2.726,1.856 -4.22,2.673 -6.003,3.267 -12.772,4.814 -19.611,4.427 -6.843,-0.345 -13.665,-2.467 -20.034,-5.594 -3.189,-1.568 -6.278,-3.391 -9.238,-5.413 -1.481,-1.011 -2.928,-2.072 -4.334,-3.178 -0.702,-0.551 -1.394,-1.116 -2.069,-1.689 -0.658,-0.558 -1.374,-1.191 -1.903,-1.695 -1.626,-1.551 -4.202,-1.491 -5.753,0.135 -0.352,0.37 -0.627,0.805 -0.813,1.249 -0.956,2.304 -2.115,4.78 -3.275,7.142 -1.174,2.383 -2.404,4.745 -3.685,7.079 -2.562,4.67 -5.322,9.235 -8.271,13.662 -5.904,8.846 -12.56,17.19 -20.13,24.521 -7.552,7.323 -16.046,13.658 -25.414,18.071 -4.667,2.225 -9.564,3.925 -14.558,5.083 -4.92,1.117 -10.064,1.566 -15.249,1.469 C 110.333,42.994 99.854,40.918 89.628,38.001 79.378,35.09 69.295,31.357 59.427,27.077 39.729,18.435 20.673,8.018 2.17,-3.113 L 2.131,-3.137 C 1.232,-3.678 0.065,-3.387 -0.476,-2.488 -0.978,-1.653 -0.755,-0.581 0,0"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(680.6455,351.1338)",
    id: "g374"
  }, /*#__PURE__*/React.createElement("path", {
    id: "path376",
    style: {
      fill: "none",
      stroke: "#2d2d2d",
      strokeWidth: 8,
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeMiterlimit: 10,
      strokeDasharray: "none",
      strokeOpacity: 1
    },
    d: "m 0,0 c 0,0 -44.045,-23.672 -52.033,-68.748 -7.988,-45.076 12.246,-84.406 12.246,-84.406"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(750.1143,274.4453)",
    id: "g378"
  }, /*#__PURE__*/React.createElement("path", {
    id: "path380",
    style: {
      fill: "#2d2d2d",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none"
    },
    d: "m 0,0 -4.775,-6.613 -2.368,-3.381 c -0.785,-1.132 -1.529,-2.284 -2.31,-3.422 -1.512,-2.301 -2.922,-4.651 -4.297,-7.038 -1.317,-2.424 -2.694,-4.744 -5.01,-7.063 l -0.009,-0.008 c -0.148,-0.149 -0.389,-0.149 -0.538,0 -0.048,0.048 -0.082,0.108 -0.098,0.171 -0.857,3.188 -0.371,6.259 0.531,9.081 0.899,2.835 1.987,5.607 3.245,8.283 0.625,1.339 1.276,2.67 1.996,3.955 0.69,1.306 1.434,2.578 2.214,3.828 0.768,1.258 1.589,2.48 2.441,3.687 0.866,1.216 1.726,2.352 2.765,3.56 1.441,1.676 3.967,1.866 5.643,0.425 C 1.014,4.103 1.271,1.77 0.074,0.103 Z"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(822.8867,257.9473)",
    id: "g382"
  }, /*#__PURE__*/React.createElement("path", {
    id: "path384",
    style: {
      fill: "#2d2d2d",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none"
    },
    d: "m 0,0 -0.229,0.82 c -0.091,0.303 -0.188,0.614 -0.294,0.921 -0.206,0.617 -0.441,1.234 -0.688,1.842 -0.497,1.216 -1.069,2.396 -1.691,3.526 -1.245,2.264 -2.791,4.274 -4.575,5.837 -3.568,3.135 -8.175,4.131 -13.151,3.094 -2.471,-0.489 -4.976,-1.391 -7.412,-2.586 -0.638,-0.265 -1.18,-0.594 -1.74,-0.909 -0.554,-0.331 -1.139,-0.584 -1.668,-0.991 l -1.627,-1.124 c -0.536,-0.39 -1.042,-0.845 -1.568,-1.262 -1.067,-0.809 -2.014,-1.83 -3.025,-2.746 -0.943,-1.016 -1.927,-1.986 -2.824,-3.067 -0.905,-1.069 -1.829,-2.125 -2.675,-3.265 -0.883,-1.105 -1.713,-2.261 -2.531,-3.43 -3.293,-4.665 -6.19,-9.681 -8.906,-14.815 -2.709,-5.14 -5.187,-10.432 -7.496,-15.808 -4.582,-10.775 -8.821,-21.728 -13.457,-32.688 l -0.002,-0.005 c -0.072,-0.171 -0.269,-0.251 -0.44,-0.178 -0.14,0.059 -0.219,0.203 -0.202,0.348 0.68,5.957 1.971,11.783 3.47,17.553 1.547,5.757 3.34,11.455 5.471,17.039 4.237,11.168 9.035,22.233 15.707,32.503 3.359,5.11 7.096,10.108 11.969,14.335 2.345,2.153 5.189,4.037 8.098,5.539 2.843,1.456 5.926,2.646 9.246,3.364 3.302,0.719 6.927,0.918 10.49,0.095 3.568,-0.756 6.906,-2.563 9.578,-4.878 C 0.5,16.729 2.576,13.956 4.187,11.049 5.002,9.597 5.692,8.097 6.288,6.566 6.585,5.8 6.864,5.029 7.113,4.24 7.241,3.847 7.359,3.449 7.475,3.043 7.593,2.618 7.688,2.268 7.812,1.72 8.302,-0.433 6.953,-2.573 4.801,-3.063 2.716,-3.536 0.642,-2.285 0.069,-0.25 Z"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(479.4287,258.8311)",
    id: "g386"
  }, /*#__PURE__*/React.createElement("path", {
    id: "path388",
    style: {
      fill: "#a5a3b2",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none"
    },
    d: "M 0,0 C 3.871,-0.774 228.903,17.549 228.903,17.549 L 297.032,204.129 63.226,188.646 10.502,66.322 -138.28,57.807 V 44.646 C -138.28,44.646 -3.871,0.774 0,0"
  })), /*#__PURE__*/React.createElement("g", {
    id: "g390"
  }, _g9 || (_g9 = /*#__PURE__*/React.createElement("g", {
    id: "g392"
  })), /*#__PURE__*/React.createElement("g", {
    id: "g404"
  }, /*#__PURE__*/React.createElement("g", {
    style: {
      opacity: 0.39999402
    },
    id: "g402",
    clipPath: "url(#clipPath396)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "g400",
    transform: "translate(543.9287,350.4141)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "path398",
    style: {
      fill: "#ffffff",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none"
    },
    d: "m 0,0 c -3.065,-0.94 -5.902,1.985 -4.859,5.018 5.598,16.288 20.77,59.549 24.746,61.85 4.903,2.839 20.903,6.195 23.226,0 C 45.436,60.675 19.371,13.966 10.854,6.224 7.1,2.81 3.193,0.979 0,0"
  }))))), /*#__PURE__*/React.createElement("g", {
    id: "g406"
  }, _g10 || (_g10 = /*#__PURE__*/React.createElement("g", {
    id: "g408"
  })), /*#__PURE__*/React.createElement("g", {
    id: "g420"
  }, /*#__PURE__*/React.createElement("g", {
    style: {
      opacity: 0.39999402
    },
    id: "g418",
    clipPath: "url(#clipPath412)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "g416",
    transform: "translate(522.416,400.5205)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "path414",
    style: {
      fill: "#ffffff",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none"
    },
    d: "m 0,0 14.72,-2.658 c 0,0 4.139,9.972 4.025,9.698 C 18.632,6.766 4.252,9.864 4.252,9.864 l 6.155,14.282 13.445,-4.803 5.677,13.678 58.86,4.635 -8.218,13.269 -59.933,-3.969 z"
  }))))), /*#__PURE__*/React.createElement("g", {
    id: "g422"
  }, _g11 || (_g11 = /*#__PURE__*/React.createElement("g", {
    id: "g424"
  })), /*#__PURE__*/React.createElement("g", {
    id: "g436"
  }, /*#__PURE__*/React.createElement("g", {
    style: {
      opacity: 0.30000299
    },
    id: "g434",
    clipPath: "url(#clipPath428)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "g432",
    transform: "translate(493.6064,259.5781)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "path430",
    style: {
      fill: "#2d2d2d",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none"
    },
    d: "m 0,0 15.5,33.627 c 0,0 79.226,0 138.635,28.441 71.646,34.3 119.977,117.372 119.977,117.372 L 214.726,16.802 Z"
  }))))), /*#__PURE__*/React.createElement("g", {
    id: "g438"
  }, _g12 || (_g12 = /*#__PURE__*/React.createElement("g", {
    id: "g440"
  })), /*#__PURE__*/React.createElement("g", {
    id: "g452"
  }, /*#__PURE__*/React.createElement("g", {
    style: {
      opacity: 0.30000299
    },
    id: "g450",
    clipPath: "url(#clipPath444)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "g448",
    transform: "translate(403.8555,283.0615)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "path446",
    style: {
      fill: "#2d2d2d",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none"
    },
    d: "M 0,0 11.684,10.862 65.767,-5.649 88.643,48.047 104.01,44.281 76.894,-21.05 73.38,-24.254 Z"
  }))))), /*#__PURE__*/React.createElement("g", {
    transform: "translate(391.439,301.2822)",
    id: "g454"
  }, /*#__PURE__*/React.createElement("path", {
    id: "path456",
    style: {
      fill: "#626272",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none"
    },
    d: "M 0,0 91.62,7.716 78.183,-23.87 Z"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(479.4287,258.8311)",
    id: "g458"
  }, /*#__PURE__*/React.createElement("path", {
    id: "path460",
    style: {
      fill: "none",
      stroke: "#2d2d2d",
      strokeWidth: 8,
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeMiterlimit: 10,
      strokeDasharray: "none",
      strokeOpacity: 1
    },
    d: "M 0,0 C 3.871,-0.774 228.903,17.549 228.903,17.549 L 297.032,204.129 63.226,188.646 10.502,66.322 -138.28,57.807 V 44.646 C -138.28,44.646 -3.871,0.774 0,0 Z"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(341.1484,316.6377)",
    id: "g462"
  }, /*#__PURE__*/React.createElement("path", {
    id: "path464",
    style: {
      fill: "none",
      stroke: "#2d2d2d",
      strokeWidth: 8,
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeMiterlimit: 10,
      strokeDasharray: "none",
      strokeOpacity: 1
    },
    d: "M 0,0 128.474,-39.226 148.783,8.516"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(479.4287,258.8311)",
    id: "g466"
  }, /*#__PURE__*/React.createElement("path", {
    id: "path468",
    style: {
      fill: "none",
      stroke: "#2d2d2d",
      strokeWidth: 8,
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeMiterlimit: 10,
      strokeDasharray: "none",
      strokeOpacity: 1
    },
    d: "m 0,0 72.517,174.71 220.102,17.334"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(363.8271,384.4062)",
    id: "g470"
  }, /*#__PURE__*/React.createElement("path", {
    id: "path472",
    style: {
      fill: "#ffffff",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none"
    },
    d: "M 0,0 V 0 C -2.757,2.573 -4.533,5.69 -4.915,9.446 -6.979,29.78 7.866,46.021 7.866,46.021 l 15.023,100.283 c -10.221,5.384 -27.015,17.891 -27.015,17.891 0,0 -74.079,-40.196 -94.208,-127.821 -7.733,-33.666 -1.594,-58.016 10.677,-75.226 0,0 35.024,56.782 87.657,38.852"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(422.9126,374.3486)",
    id: "g474"
  }, /*#__PURE__*/React.createElement("path", {
    id: "path476",
    style: {
      fill: "#00c7be",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none"
    },
    d: "m 0,0 c -15.569,-2.026 -46.916,-1.298 -59.085,10.058 -52.634,17.929 -87.658,-38.852 -87.658,-38.852 19.667,-27.583 55.097,-36.811 74.485,-36.557 31.484,0.414 37.757,4.446 53.201,-11.505 15.444,-15.952 55.423,3.662 59.175,27.662 C 43.871,-25.194 19.097,2.485 0,0"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(263.1206,407.7744)",
    id: "g478"
  }, /*#__PURE__*/React.createElement("path", {
    id: "path480",
    style: {
      fill: "#777777",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none"
    },
    d: "M 0,0 C 0,0 28.667,-14.645 4.681,-46.891"
  })), /*#__PURE__*/React.createElement("g", {
    id: "g482"
  }, _g13 || (_g13 = /*#__PURE__*/React.createElement("g", {
    id: "g484"
  })), /*#__PURE__*/React.createElement("g", {
    id: "g496"
  }, /*#__PURE__*/React.createElement("g", {
    style: {
      opacity: 0.30000299
    },
    id: "g494",
    clipPath: "url(#clipPath488)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "g492",
    transform: "translate(266.2676,425.7988)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "path490",
    style: {
      fill: "#2d2d2d",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none"
    },
    d: "m 0,0 c 0,0 3.578,-69.137 43.337,-86.697 39.76,-17.561 75.372,-11.367 86.211,-13.949 10.839,-2.58 15.168,-11.612 34.939,-8.773 19.771,2.838 29.319,23.512 31.126,29.175 0,0 6.35,-19.433 -3.277,-31.595 -9.627,-12.161 -27.216,-23.471 -41.002,-22.203 -13.786,1.268 -18.815,14.118 -31.978,17.241 -13.163,3.123 -59.588,-7.928 -90.891,18.179 C -2.839,-72.517 -9.807,-43.354 0,0"
  }))))), /*#__PURE__*/React.createElement("g", {
    transform: "translate(373.0937,429.1475)",
    id: "g498"
  }, /*#__PURE__*/React.createElement("path", {
    id: "path500",
    style: {
      fill: "#2d2d2d",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none"
    },
    d: "m 0,0 c -1.848,-2.488 -3.615,-5.308 -5.083,-8.146 -1.509,-2.841 -2.761,-5.801 -3.732,-8.817 -0.521,-1.499 -0.896,-3.029 -1.283,-4.553 -0.171,-0.764 -0.284,-1.539 -0.431,-2.306 l -0.208,-1.152 -0.121,-1.159 c -0.438,-3.056 -0.284,-6.241 0.023,-9.152 0.631,-5.154 5.52,-8.919 11.151,-11.233 5.665,-2.377 12.053,-3.614 18.454,-4.375 6.422,-0.772 12.968,-1.013 19.474,-0.825 3.25,0.102 6.502,0.302 9.682,0.677 l 1.189,0.145 c 0.399,0.049 0.98,0.093 1.463,0.135 1.015,0.12 2.011,0.054 3.015,0.053 1.976,-0.149 3.94,-0.417 5.782,-0.958 3.73,-0.993 7.102,-2.676 10.198,-4.644 3.096,-1.978 5.912,-4.288 8.477,-6.821 5.103,-5.089 9.255,-11.057 12.193,-17.673 2.901,-6.599 4.618,-13.986 3.941,-21.534 -0.185,-1.853 -0.492,-3.798 -1.029,-5.655 -0.274,-0.923 -0.531,-1.856 -0.904,-2.731 l -0.522,-1.331 c -0.183,-0.438 -0.401,-0.854 -0.602,-1.282 -1.634,-3.406 -3.758,-6.474 -6.151,-9.23 -4.812,-5.506 -10.649,-9.853 -17.028,-13.139 -6.392,-3.239 -13.408,-5.523 -20.956,-5.749 -3.756,-0.081 -7.687,0.358 -11.44,1.889 l -1.395,0.595 c -0.464,0.2 -0.901,0.48 -1.351,0.72 -0.91,0.466 -1.744,1.075 -2.575,1.688 -0.847,0.588 -1.558,1.353 -2.328,2.038 l -1.714,1.687 c -1.116,1.162 -2.309,2.117 -3.464,3.165 -1.2,0.912 -2.382,1.871 -3.626,2.596 -2.47,1.53 -5.045,2.515 -7.915,3.025 -2.866,0.518 -5.995,0.625 -9.249,0.572 -3.236,-0.032 -6.568,-0.184 -9.917,-0.316 -3.352,-0.135 -6.727,-0.261 -10.107,-0.339 -1.71,-0.024 -3.342,-0.094 -5.116,-0.081 -0.889,0.014 -1.783,0.01 -2.669,0.041 l -2.644,0.15 c -14.012,1.106 -27.521,5.051 -39.978,11.352 -12.411,6.3 -23.737,15.329 -31.911,26.927 -8.221,11.553 -12.936,25.417 -14.247,39.335 -0.128,0.869 -0.172,1.741 -0.21,2.613 l -0.135,2.615 -0.131,2.617 c -0.007,0.87 0.02,1.739 0.029,2.609 0.04,1.738 0.029,3.482 0.114,5.216 l 0.415,5.183 c 0.098,1.736 0.368,3.441 0.611,5.152 0.252,1.708 0.462,3.426 0.753,5.125 l 1.015,5.063 0.51,2.532 c 0.186,0.838 0.412,1.662 0.616,2.493 6.398,26.629 18.597,51.797 35.144,73.528 8.291,10.854 17.523,20.978 27.633,30.141 5.048,4.587 10.299,8.953 15.764,13.051 2.719,2.067 5.517,4.035 8.353,5.958 1.421,0.958 2.858,1.896 4.319,2.812 1.475,0.929 2.897,1.788 4.536,2.704 1.401,0.784 3.075,0.624 4.288,-0.273 l 0.048,-0.037 c 2.12,-1.574 4.309,-3.152 6.486,-4.698 2.183,-1.548 4.377,-3.079 6.587,-4.572 2.21,-1.491 4.429,-2.966 6.667,-4.366 2.234,-1.399 4.489,-2.761 6.728,-3.953 l 0.024,-0.013 c 1.95,-1.039 2.689,-3.461 1.651,-5.411 -1.038,-1.95 -3.453,-2.693 -5.404,-1.655 -2.534,1.343 -4.909,2.776 -7.258,4.239 -2.348,1.461 -4.633,2.973 -6.906,4.5 -2.272,1.527 -4.514,3.083 -6.743,4.656 -2.233,1.579 -4.431,3.156 -6.654,4.798 l 4.336,-0.31 c -1.283,-0.722 -2.73,-1.593 -4.085,-2.454 -1.375,-0.866 -2.741,-1.762 -4.095,-2.68 -2.703,-1.842 -5.383,-3.734 -7.993,-5.728 -5.244,-3.951 -10.297,-8.171 -15.153,-12.604 -9.728,-8.855 -18.599,-18.633 -26.548,-29.086 -15.832,-20.952 -27.531,-45 -33.679,-70.496 -0.196,-0.795 -0.415,-1.587 -0.592,-2.383 l -0.482,-2.394 -0.966,-4.786 c -0.275,-1.601 -0.469,-3.21 -0.709,-4.815 -0.23,-1.605 -0.489,-3.209 -0.576,-4.822 l -0.393,-4.832 c -0.079,-1.609 -0.066,-3.219 -0.106,-4.828 -0.01,-0.804 -0.038,-1.609 -0.033,-2.413 l 0.123,-2.401 0.12,-2.403 c 0.032,-0.801 0.071,-1.601 0.19,-2.391 1.2,-12.729 5.422,-25.061 12.746,-35.39 7.285,-10.359 17.493,-18.566 28.922,-24.381 11.424,-5.812 24.132,-9.511 36.838,-10.511 l 2.372,-0.136 c 0.787,-0.028 1.568,-0.023 2.353,-0.037 1.575,-0.017 3.292,0.052 4.931,0.074 3.317,0.075 6.636,0.195 9.977,0.328 3.344,0.128 6.705,0.281 10.167,0.313 3.437,0.047 7.042,-0.039 10.773,-0.71 3.727,-0.644 7.511,-2.091 10.721,-4.108 1.649,-0.978 3.077,-2.125 4.536,-3.251 1.332,-1.193 2.744,-2.353 3.953,-3.607 l 1.864,-1.841 c 0.497,-0.405 0.911,-0.907 1.45,-1.263 0.523,-0.376 1.03,-0.773 1.621,-1.06 0.29,-0.151 0.554,-0.341 0.862,-0.467 l 0.917,-0.388 c 2.46,-1.024 5.33,-1.385 8.249,-1.32 5.877,0.154 11.949,2.04 17.464,4.85 5.522,2.831 10.612,6.645 14.62,11.235 1.996,2.295 3.709,4.79 4.974,7.424 0.155,0.33 0.331,0.654 0.469,0.988 l 0.393,1.009 c 0.293,0.666 0.468,1.353 0.676,2.034 0.397,1.36 0.612,2.737 0.768,4.213 0.54,5.842 -0.803,11.946 -3.275,17.568 -2.489,5.632 -6.11,10.856 -10.491,15.225 -2.198,2.174 -4.593,4.131 -7.141,5.761 -2.543,1.628 -5.251,2.945 -8,3.688 -1.371,0.425 -2.747,0.595 -4.104,0.724 -0.669,-0.008 -1.352,0.066 -2.003,-0.022 -0.351,-0.032 -0.607,-0.033 -1.039,-0.082 l -1.306,-0.15 c -3.477,-0.38 -6.919,-0.562 -10.364,-0.643 -6.885,-0.143 -13.761,0.162 -20.636,1.044 -6.857,0.95 -13.744,2.411 -20.399,5.358 l -1.242,0.568 -1.224,0.646 c -0.82,0.408 -1.614,0.92 -2.41,1.41 -0.798,0.485 -1.556,1.09 -2.328,1.639 -0.73,0.652 -1.503,1.214 -2.179,1.954 -1.427,1.355 -2.616,3.057 -3.617,4.851 -0.904,1.863 -1.586,3.871 -1.799,5.924 -0.098,0.534 -0.089,0.96 -0.112,1.419 l -0.053,1.362 c -0.026,0.907 -0.099,1.814 -0.01,2.717 l 0.168,2.706 c 0.077,0.898 0.247,1.783 0.369,2.674 0.556,3.547 1.543,6.999 2.886,10.263 1.342,3.269 2.964,6.388 4.833,9.33 0.951,1.462 1.961,2.88 3.033,4.251 1.073,1.39 2.17,2.673 3.471,3.988 0.737,0.745 1.938,0.751 2.683,0.013 0.68,-0.673 0.744,-1.732 0.189,-2.478 z"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(276.1699,345.5547)",
    id: "g502"
  }, /*#__PURE__*/React.createElement("path", {
    id: "path504",
    style: {
      fill: "none",
      stroke: "#2d2d2d",
      strokeWidth: 7,
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeMiterlimit: 10,
      strokeDasharray: "none",
      strokeOpacity: 1
    },
    d: "M 0,0 C 0,0 35.024,56.781 87.657,38.852"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(263.1206,407.7744)",
    id: "g506"
  }, /*#__PURE__*/React.createElement("path", {
    id: "path508",
    style: {
      fill: "none",
      stroke: "#2d2d2d",
      strokeWidth: 7,
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeMiterlimit: 10,
      strokeDasharray: "none",
      strokeOpacity: 1
    },
    d: "M 0,0 C 0,0 28.667,-14.645 4.681,-46.891"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(437.4126,445.291)",
    id: "g510"
  }, /*#__PURE__*/React.createElement("path", {
    id: "path512",
    style: {
      fill: "#777777",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none"
    },
    d: "m 0,0 c 0,0 -30.732,42.795 -57.878,64.437 -20.18,16.087 -49.25,10.056 -62.372,8.047 0,0 1.485,13.424 8.79,19.699 21.296,18.294 58.516,12.553 71.561,1.467 C -16.961,74.154 22.234,33.909 41.436,0.271"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(437.4126,445.291)",
    id: "g514"
  }, /*#__PURE__*/React.createElement("path", {
    id: "path516",
    style: {
      fill: "#00c7be",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none"
    },
    d: "m 0,0 41.436,0.271 9.891,-16.3 L 9.892,-16.3 Z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "g518"
  }, _g14 || (_g14 = /*#__PURE__*/React.createElement("g", {
    id: "g520"
  })), /*#__PURE__*/React.createElement("g", {
    id: "g532"
  }, /*#__PURE__*/React.createElement("g", {
    style: {
      opacity: 0.30000299
    },
    id: "g530",
    clipPath: "url(#clipPath524)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "g528",
    transform: "translate(463.083,430.6152)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "path526",
    style: {
      fill: "#2d2d2d",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none"
    },
    d: "m 0,0 c 0,0 -52.352,68.405 -61.238,75.301 l -19.783,-0.129 c 0,0 -2.495,2.053 -3.337,2.723 -0.842,0.67 -2.34,3.614 -2.34,3.614 0,0 4.171,1.726 6.135,1.831 1.965,0.105 12.805,0.784 12.805,0.784 0,0 -14.953,14.632 -24.599,16.478 -34.256,6.557 -47.369,-12.463 -47.369,-12.463 0,0 43.246,16.585 83.047,-33.832 27.6,-34.962 41.585,-54.912 41.585,-54.912 0,0 4.248,-0.987 5.235,-0.981 C -8.873,-1.579 0,0 0,0"
  }))))), /*#__PURE__*/React.createElement("g", {
    transform: "translate(437.4126,445.291)",
    id: "g534"
  }, /*#__PURE__*/React.createElement("path", {
    id: "path536",
    style: {
      fill: "none",
      stroke: "#2d2d2d",
      strokeWidth: 6,
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeMiterlimit: 10,
      strokeDasharray: "none",
      strokeOpacity: 1
    },
    d: "m 0,0 41.436,0.271 9.891,-16.3 L 9.892,-16.3 Z"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(437.4126,445.291)",
    id: "g538"
  }, /*#__PURE__*/React.createElement("path", {
    id: "path540",
    style: {
      fill: "none",
      stroke: "#2d2d2d",
      strokeWidth: 6,
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeMiterlimit: 10,
      strokeDasharray: "none",
      strokeOpacity: 1
    },
    d: "m 0,0 c 0,0 -30.732,42.795 -57.878,64.437 -20.18,16.087 -49.25,10.056 -62.372,8.047 0,0 1.485,13.424 8.79,19.699 21.296,18.294 58.516,12.553 71.561,1.467 C -16.961,74.154 22.234,33.909 41.436,0.271"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(446.5937,489.6074)",
    id: "g542"
  }, /*#__PURE__*/React.createElement("path", {
    id: "path544",
    style: {
      fill: "none",
      stroke: "#2d2d2d",
      strokeWidth: 6,
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeMiterlimit: 10,
      strokeDasharray: "none",
      strokeOpacity: 1
    },
    d: "M 0,0 -44.679,-0.291"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(421.6147,516.0454)",
    id: "g546"
  }, /*#__PURE__*/React.createElement("path", {
    id: "path548",
    style: {
      fill: "none",
      stroke: "#2d2d2d",
      strokeWidth: 6,
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeMiterlimit: 10,
      strokeDasharray: "none",
      strokeOpacity: 1
    },
    d: "M 0,0 -46.163,-2.468"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(602.04,814.6357)",
    id: "g550"
  }, /*#__PURE__*/React.createElement("path", {
    id: "path552",
    style: {
      fill: "#ffffff",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none"
    },
    d: "m 0,0 c -34.113,20.801 -73.553,31.824 -113.507,31.724 -127.264,-0.319 -181.242,-119.335 -177.233,-208.932 4.58,-102.397 143.683,-130.032 143.683,-130.032 0,0 133.274,-48.491 190.282,36.693 C 93.105,-196.011 108.658,-66.256 0,0"
  })), /*#__PURE__*/React.createElement("g", {
    id: "g554"
  }, _g15 || (_g15 = /*#__PURE__*/React.createElement("g", {
    id: "g556"
  })), /*#__PURE__*/React.createElement("g", {
    id: "g568"
  }, /*#__PURE__*/React.createElement("g", {
    style: {
      opacity: 0.30000299
    },
    id: "g566",
    clipPath: "url(#clipPath560)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "g564",
    transform: "translate(481.3013,521.1074)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "path562",
    style: {
      fill: "#2d2d2d",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none"
    },
    d: "m 0,0 c 0,0 -139.103,27.635 -143.684,130.032 -2.86,63.949 23.829,142.874 85.611,182.942 -80.541,-32.678 -115.167,-124.262 -111.928,-196.654 4.58,-102.397 143.683,-130.032 143.683,-130.032 0,0 99.507,-36.191 163.335,8.932 C 75.387,-27.423 0,0 0,0"
  }))))), /*#__PURE__*/React.createElement("g", {
    transform: "translate(604.1826,746.5688)",
    id: "g570"
  }, /*#__PURE__*/React.createElement("path", {
    id: "path572",
    style: {
      fill: "none",
      stroke: "#2d2d2d",
      strokeWidth: 6,
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeMiterlimit: 10,
      strokeDasharray: "none",
      strokeOpacity: 1
    },
    d: "M 0,0 C 0,0 8.538,42.685 -25.497,80.413"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(551.4375,757.0659)",
    id: "g574"
  }, /*#__PURE__*/React.createElement("path", {
    id: "path576",
    style: {
      fill: "none",
      stroke: "#2d2d2d",
      strokeWidth: 6,
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeMiterlimit: 10,
      strokeDasharray: "none",
      strokeOpacity: 1
    },
    d: "M 0,0 C 0,0 -4.749,59.181 -105.795,84.254"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(602.04,814.6357)",
    id: "g578"
  }, /*#__PURE__*/React.createElement("path", {
    id: "path580",
    style: {
      fill: "none",
      stroke: "#2d2d2d",
      strokeWidth: 8,
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeMiterlimit: 10,
      strokeDasharray: "none",
      strokeOpacity: 1
    },
    d: "m 0,0 c -17.694,10.79 -36.822,18.949 -56.712,24.289 -18.455,4.955 -37.565,7.483 -56.795,7.435 -79.116,-0.198 -128.952,-42.848 -154.374,-96.617 -15.473,-32.723 -24.651,-79.4 -23.134,-113.298 4.581,-102.398 143.143,-131.967 143.143,-131.967 0,0 133.813,-46.557 190.821,38.627 19.674,29.397 36.371,75.842 39.384,113.467 C 86.96,-100.292 65.804,-40.125 0,0 Z"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(684.373,656.5718)",
    id: "g582"
  }, /*#__PURE__*/React.createElement("path", {
    id: "path584",
    style: {
      fill: "#2d2d2d",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none"
    },
    d: "m 0,0 c 1.43,17.857 0.388,35.941 -3.665,53.593 -24.361,19.144 -62.103,35.306 -110.146,43.964 -74.847,13.487 -132.669,1.209 -156.441,-24.97 -23.773,-26.179 -48.117,-108.401 -23.557,-146.276 24.559,-37.875 138.82,-57.27 138.82,-57.27 0,0 47.997,-9.148 91.58,-8.198 8.901,6.808 17.042,15.255 24.025,25.69 C -19.71,-84.07 -3.013,-37.625 0,0"
  })), /*#__PURE__*/React.createElement("g", {
    id: "g586"
  }, _g16 || (_g16 = /*#__PURE__*/React.createElement("g", {
    id: "g588"
  })), /*#__PURE__*/React.createElement("g", {
    id: "g600"
  }, /*#__PURE__*/React.createElement("g", {
    style: {
      opacity: 0.39999402
    },
    id: "g598",
    clipPath: "url(#clipPath592)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "g596",
    transform: "translate(461.2598,713.8975)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "path594",
    style: {
      fill: "#ffffff",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none"
    },
    d: "M 0,0 C 21.171,20.312 120.513,21.056 114.221,22.465 47.504,37.411 -4.251,30.066 -25.729,9.459 -38.472,-2.767 -51.581,-31.405 -55.628,-59.514 c -0.484,-3.355 1.018,-6.667 3.738,-8.427 8.683,-5.62 20.133,-0.774 22.783,9.699 C -22.88,-33.624 -11.307,-10.849 0,0"
  }))))), /*#__PURE__*/React.createElement("g", {
    id: "g602"
  }, _g17 || (_g17 = /*#__PURE__*/React.createElement("g", {
    id: "g604"
  })), /*#__PURE__*/React.createElement("g", {
    id: "g616"
  }, /*#__PURE__*/React.createElement("g", {
    style: {
      opacity: 0.39999402
    },
    id: "g614",
    clipPath: "url(#clipPath608)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "g612",
    transform: "translate(659.9111,597.1689)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "path610",
    style: {
      fill: "#ffffff",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none"
    },
    d: "m 0,0 c -4.342,-10.091 -14.099,-15.301 -21.792,-11.638 -7.693,3.664 -10.41,14.815 -6.068,24.906 4.342,10.09 14.099,15.301 21.792,11.637 C 1.625,21.241 4.342,10.091 0,0"
  }))))), /*#__PURE__*/React.createElement("g", {
    id: "g618"
  }, _g18 || (_g18 = /*#__PURE__*/React.createElement("g", {
    id: "g620"
  })), /*#__PURE__*/React.createElement("g", {
    id: "g632"
  }, /*#__PURE__*/React.createElement("g", {
    style: {
      opacity: 0.39999402
    },
    id: "g630",
    clipPath: "url(#clipPath624)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "g628",
    transform: "translate(624.8994,563.7944)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "path626",
    style: {
      fill: "#ffffff",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none"
    },
    d: "m 0,0 c -4.01,-3.824 -10.159,-3.504 -13.734,0.713 -3.576,4.218 -3.223,10.737 0.787,14.561 4.009,3.824 10.159,3.505 13.734,-0.713 C 4.362,10.343 4.011,3.824 0,0"
  }))))), /*#__PURE__*/React.createElement("g", {
    transform: "translate(399.9922,612.8223)",
    id: "g634"
  }, /*#__PURE__*/React.createElement("path", {
    id: "path636",
    style: {
      fill: "#161616",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none"
    },
    d: "M 0,0 C -12.564,19.376 -10.512,56.12 -4.102,85.268 -19.16,49.389 -27.427,-2.183 -9.428,-29.94 c 24.559,-37.874 138.82,-57.269 138.82,-57.269 0,0 47.997,-9.149 91.58,-8.199 8.901,6.809 24.025,25.691 24.025,25.691 -50.801,2.61 -106.177,12.447 -106.177,12.447 0,0 -114.26,19.395 -138.82,57.27"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(684.373,656.5718)",
    id: "g638"
  }, /*#__PURE__*/React.createElement("path", {
    id: "path640",
    style: {
      fill: "none",
      stroke: "#2d2d2d",
      strokeWidth: 8,
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeMiterlimit: 10,
      strokeDasharray: "none",
      strokeOpacity: 1
    },
    d: "m 0,0 c 1.43,17.857 0.388,35.941 -3.665,53.593 -24.361,19.144 -62.103,35.306 -110.146,43.964 -74.847,13.487 -132.669,1.209 -156.441,-24.97 -23.773,-26.179 -48.117,-108.401 -23.557,-146.276 24.559,-37.875 138.82,-57.27 138.82,-57.27 0,0 47.997,-9.148 91.58,-8.198 8.901,6.808 17.042,15.255 24.025,25.69 C -19.71,-84.07 -3.013,-37.625 0,0 Z"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(374.8052,728.0508)",
    id: "g642"
  }, /*#__PURE__*/React.createElement("path", {
    id: "path644",
    style: {
      fill: "#ffffff",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none"
    },
    d: "M 0,0 C -2.045,0.518 -4.17,0.477 -6.332,-0.037 L -27.71,-0.16 c -14.362,3.634 -31.816,-16.386 -38.985,-44.716 -7.169,-28.331 -1.339,-54.243 13.023,-57.878 l 18.746,-10.277 c 1.657,-1.48 3.507,-2.526 5.552,-3.044 14.362,-3.634 32.58,19.404 40.691,51.457 C 19.429,-32.564 14.362,-3.634 0,0"
  })), /*#__PURE__*/React.createElement("g", {
    id: "g646"
  }, _g19 || (_g19 = /*#__PURE__*/React.createElement("g", {
    id: "g648"
  })), /*#__PURE__*/React.createElement("g", {
    id: "g660"
  }, /*#__PURE__*/React.createElement("g", {
    style: {
      opacity: 0.30000299
    },
    id: "g658",
    clipPath: "url(#clipPath652)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "g656",
    transform: "translate(335.0781,625.7324)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "path654",
    style: {
      fill: "#2d2d2d",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none"
    },
    d: "m 0,0 20.958,-12.117 c 0,0 12.037,6.748 18.495,20.306 6.457,13.558 12.031,31.249 12.031,31.249 l 2.238,11.739 c 0,0 -7.149,-12.345 -13.144,-12.999 C 34.75,37.542 25.583,40.565 25.583,40.565 25.583,40.565 20.045,15.03 0,0"
  }))))), /*#__PURE__*/React.createElement("g", {
    transform: "translate(374.8052,728.0508)",
    id: "g662"
  }, /*#__PURE__*/React.createElement("path", {
    id: "path664",
    style: {
      fill: "none",
      stroke: "#2d2d2d",
      strokeWidth: 8,
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeMiterlimit: 10,
      strokeDasharray: "none",
      strokeOpacity: 1
    },
    d: "m 0,0 c -2.045,0.518 -27.634,2.082 -27.634,2.082 -14.362,3.634 -31.892,-18.628 -39.061,-46.958 -7.169,-28.331 -3.192,-55.92 11.17,-59.555 0,0 24.106,-11.126 26.151,-11.644 14.362,-3.634 32.58,19.404 40.691,51.457 C 19.429,-32.564 14.362,-3.634 0,0 Z"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(365.4858,668.6553)",
    id: "g666"
  }, /*#__PURE__*/React.createElement("path", {
    id: "path668",
    style: {
      fill: "#ffffff",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none"
    },
    d: "m 0,0 c -7.478,-29.549 -27.049,-50.085 -43.714,-45.868 -16.664,4.218 -24.112,31.591 -16.635,61.139 7.478,29.549 27.049,50.085 43.714,45.868 C 0.03,56.922 7.478,29.549 0,0"
  })), /*#__PURE__*/React.createElement("g", {
    id: "g670"
  }, _g20 || (_g20 = /*#__PURE__*/React.createElement("g", {
    id: "g672"
  })), /*#__PURE__*/React.createElement("g", {
    id: "g684"
  }, /*#__PURE__*/React.createElement("g", {
    style: {
      opacity: 0.30000299
    },
    id: "g682",
    clipPath: "url(#clipPath676)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "g680",
    transform: "translate(366.5869,707.2666)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "path678",
    style: {
      fill: "#2d2d2d",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none"
    },
    d: "m 0,0 c -0.469,-4.28 -1.25,-8.678 -2.376,-13.128 -7.478,-29.55 -27.049,-50.085 -43.714,-45.868 -8.692,2.2 -14.869,10.706 -17.736,22.528 -2.643,-24.138 4.856,-44.429 19.011,-48.011 16.665,-4.217 36.236,16.318 43.714,45.868 C 2.477,-24.475 2.63,-10.843 0,0"
  }))))), /*#__PURE__*/React.createElement("g", {
    transform: "translate(365.4858,668.6553)",
    id: "g686"
  }, /*#__PURE__*/React.createElement("path", {
    id: "path688",
    style: {
      fill: "none",
      stroke: "#2d2d2d",
      strokeWidth: 8,
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeMiterlimit: 10,
      strokeDasharray: "none",
      strokeOpacity: 1
    },
    d: "m 0,0 c -7.478,-29.549 -27.049,-50.085 -43.714,-45.868 -16.664,4.218 -24.112,31.591 -16.635,61.139 7.478,29.549 27.049,50.085 43.714,45.868 C 0.03,56.922 7.478,29.549 0,0 Z"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(557.9893,302.7441)",
    id: "g690"
  }, /*#__PURE__*/React.createElement("path", {
    id: "path692",
    style: {
      fill: "#ffffff",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none"
    },
    d: "M 0,0 C -0.693,-0.567 -1.399,-1.157 -2.115,-1.769 -1.399,-1.157 -0.693,-0.567 0,0"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(551.4785,297.041)",
    id: "g694"
  }, /*#__PURE__*/React.createElement("path", {
    id: "path696",
    style: {
      fill: "#ffffff",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none"
    },
    d: "M 0,0 C -1.119,-1.051 -2.25,-2.149 -3.384,-3.299 -2.25,-2.149 -1.119,-1.05 0,0"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(553.6992,299.0742)",
    id: "g698"
  }, /*#__PURE__*/React.createElement("path", {
    id: "path700",
    style: {
      fill: "#ffffff",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none"
    },
    d: "M 0,0 C -0.733,-0.655 -1.475,-1.334 -2.221,-2.033 -1.475,-1.333 -0.733,-0.655 0,0"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(562.917,306.5791)",
    id: "g702"
  }, /*#__PURE__*/React.createElement("path", {
    id: "path704",
    style: {
      fill: "#ffffff",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none"
    },
    d: "M 0,0 C -0.615,-0.456 -1.25,-0.934 -1.9,-1.434 -1.25,-0.934 -0.615,-0.456 0,0"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(569.2598,310.9629)",
    id: "g706"
  }, /*#__PURE__*/React.createElement("path", {
    id: "path708",
    style: {
      fill: "#ffffff",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none"
    },
    d: "M 0,0 C -0.429,-0.274 -0.885,-0.572 -1.367,-0.893 -0.885,-0.572 -0.429,-0.274 0,0"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(521.3437,244.6973)",
    id: "g710"
  }, /*#__PURE__*/React.createElement("path", {
    id: "path712",
    style: {
      fill: "#00c7be",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none"
    },
    d: "m 0,0 c 3.12,17.607 11.742,31.949 21.092,42.89 1.496,1.751 3.011,3.414 4.524,4.99 0.378,0.393 0.757,0.782 1.135,1.165 1.134,1.149 2.265,2.248 3.384,3.299 0.746,0.699 1.487,1.378 2.22,2.033 0.734,0.656 1.459,1.29 2.175,1.901 0.716,0.612 1.422,1.201 2.116,1.769 1.04,0.85 2.051,1.65 3.027,2.401 0.65,0.5 1.285,0.978 1.9,1.434 1.848,1.366 3.529,2.53 4.976,3.491 0.482,0.32 0.938,0.618 1.367,0.893 2.568,1.649 4.117,2.482 4.117,2.482 43.793,-18.113 66.362,-74.169 66.362,-74.169 0,0 33.378,32.523 65.045,11.982 31.668,-20.54 10.271,-106.127 -37.658,-124.101 -47.928,-17.973 -133.537,33.134 -133.537,33.134 0,0 -14.404,28 -14.107,63.825 C -1.808,-13.946 -1.248,-7.044 0,0"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(546.96,292.5771)",
    id: "g714"
  }, /*#__PURE__*/React.createElement("path", {
    id: "path716",
    style: {
      fill: "#ffffff",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none"
    },
    d: "M 0,0 C -1.514,-1.576 -3.028,-3.239 -4.524,-4.99 -3.028,-3.239 -1.514,-1.576 0,0"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(519.4814,224.1162)",
    id: "g718"
  }, /*#__PURE__*/React.createElement("path", {
    id: "path720",
    style: {
      fill: "#ffffff",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none"
    },
    d: "M 0,0 C -0.297,-35.825 14.107,-63.825 14.107,-63.825 14.107,-63.824 -0.297,-35.825 0,0"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(395.7598,153.583)",
    id: "g722"
  }, /*#__PURE__*/React.createElement("path", {
    id: "path724",
    style: {
      fill: "#ffffff",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none"
    },
    d: "m 0,0 39.611,122.067 c 0,0 75.132,53.493 126.484,41.51 3.991,-0.931 7.832,-2.189 11.522,-3.715 0,0 -1.549,-0.833 -4.117,-2.482 -0.429,-0.275 -0.885,-0.572 -1.367,-0.893 -1.447,-0.961 -3.128,-2.125 -4.976,-3.491 -0.615,-0.456 -1.25,-0.934 -1.9,-1.434 -0.976,-0.75 -1.987,-1.55 -3.028,-2.401 -0.693,-0.567 -1.399,-1.157 -2.115,-1.768 -0.716,-0.612 -1.441,-1.246 -2.175,-1.902 -0.733,-0.655 -1.474,-1.333 -2.22,-2.033 -1.119,-1.05 -2.25,-2.149 -3.384,-3.299 -0.378,-0.383 -0.757,-0.771 -1.135,-1.165 -1.513,-1.576 -3.028,-3.239 -4.524,-4.99 -9.35,-10.941 -17.972,-25.282 -21.092,-42.89 -1.248,-7.043 -1.808,-13.946 -1.862,-20.581 C 123.425,34.708 137.829,6.709 137.829,6.708 137.828,6.707 57.286,-32.63 0,0"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(519.4814,224.1162)",
    id: "g726"
  }, /*#__PURE__*/React.createElement("path", {
    id: "path728",
    style: {
      fill: "#ffffff",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none"
    },
    d: "M 0,0 C 0.055,6.635 0.614,13.538 1.862,20.581 4.982,38.188 13.604,52.53 22.954,63.471 13.604,52.53 4.982,38.188 1.862,20.581 0.614,13.537 0.055,6.635 0,0"
  })), /*#__PURE__*/React.createElement("g", {
    id: "g730"
  }, _g21 || (_g21 = /*#__PURE__*/React.createElement("g", {
    id: "g732"
  })), /*#__PURE__*/React.createElement("g", {
    id: "g744"
  }, /*#__PURE__*/React.createElement("g", {
    style: {
      opacity: 0.39999402
    },
    id: "g742",
    clipPath: "url(#clipPath736)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "g740",
    transform: "translate(697.082,242.7002)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "path738",
    style: {
      fill: "#ffffff",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none"
    },
    d: "m 0,0 c 0,0 -17.831,6.704 -35.091,0.855 -17.26,-5.848 -30.24,-15.974 -30.24,-15.974 l 1.536,2.513 c 0,0 -34.309,62.465 -72.27,75.051 l 8.243,5.818 6.203,1.584 c 0,0 17.631,-9.815 31.967,-24.96 14.336,-15.146 32.308,-44.673 32.308,-44.673 0,0 2.14,-0.857 3.21,-0.214 1.07,0.642 12.624,11.768 34.877,14.978 22.252,3.209 33.219,-12.116 33.219,-12.116 0,0 3.896,-4.042 3.205,-4.842 -0.691,-0.802 -3.688,-2.514 -3.688,-2.514 l -7.06,2.514 z"
  }))))), /*#__PURE__*/React.createElement("g", {
    id: "g746"
  }, _g22 || (_g22 = /*#__PURE__*/React.createElement("g", {
    id: "g748"
  })), /*#__PURE__*/React.createElement("g", {
    id: "g760"
  }, /*#__PURE__*/React.createElement("g", {
    style: {
      opacity: 0.30000299
    },
    id: "g758",
    clipPath: "url(#clipPath752)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "g756",
    transform: "translate(667.126,127.1572)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "path754",
    style: {
      fill: "#2d2d2d",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none"
    },
    d: "m 0,0 c -47.928,-17.973 -133.537,33.134 -133.537,33.134 -0.001,-10e-4 -80.543,-39.338 -137.829,-6.708 l 39.611,122.067 c 0,0 3.932,2.799 10.599,6.966 -31.153,-47.382 36.289,-50.615 69.24,-52.844 32.951,-2.227 102.704,-72.231 124.528,-34.573 21.826,37.658 39.893,38.083 39.893,38.083 C 0.404,96.921 -4.554,84.643 -4.554,84.643 c 0,0 14.061,18.847 34.51,17.972 C 50.287,101.746 50.803,70.426 50.808,70.064 45.165,41.017 26.704,10.015 0,0"
  }))))), /*#__PURE__*/React.createElement("g", {
    transform: "translate(424.6865,271.6201)",
    id: "g762"
  }, /*#__PURE__*/React.createElement("path", {
    id: "path764",
    style: {
      fill: "#2d2d2d",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none"
    },
    d: "m 0,0 c 4.394,3.355 8.865,6.479 13.452,9.487 2.288,1.506 4.591,2.989 6.91,4.45 2.327,1.445 4.682,2.845 7.043,4.237 9.437,5.584 19.186,10.653 29.177,15.268 9.999,4.59 20.261,8.722 30.902,11.927 10.654,3.109 21.693,5.413 33.09,5.694 5.688,0.142 11.47,-0.301 17.172,-1.558 5.607,-1.291 11.047,-3.187 16.204,-5.638 10.347,-4.87 19.529,-11.748 27.584,-19.546 8.074,-7.812 15.066,-16.582 21.244,-25.822 3.085,-4.626 5.964,-9.38 8.639,-14.248 1.338,-2.435 2.624,-4.897 3.855,-7.394 1.238,-2.521 2.396,-4.971 3.527,-7.692 l -6.566,1.385 c 0.833,0.794 1.533,1.403 2.307,2.065 0.76,0.646 1.526,1.272 2.303,1.884 1.553,1.223 3.142,2.389 4.769,3.502 3.256,2.226 6.664,4.244 10.231,6.001 7.116,3.495 14.956,6.001 23.188,6.43 4.102,0.216 8.273,-0.102 12.32,-1.02 4.047,-0.911 7.957,-2.404 11.575,-4.358 1.805,-0.992 3.517,-2.028 5.304,-3.372 1.742,-1.315 3.291,-2.849 4.695,-4.476 1.41,-1.627 2.62,-3.392 3.67,-5.217 1.064,-1.822 1.956,-3.715 2.699,-5.641 2.998,-7.726 3.905,-15.809 3.845,-23.694 -0.098,-7.904 -1.217,-15.695 -3.077,-23.269 -1.861,-7.577 -4.446,-14.956 -7.734,-22.027 -3.286,-7.067 -7.258,-13.84 -11.987,-20.113 -4.74,-6.257 -10.268,-12.012 -16.654,-16.812 -6.394,-4.752 -13.7,-8.571 -21.58,-10.561 -7.821,-2.016 -15.809,-2.527 -23.619,-2.194 -7.822,0.336 -15.51,1.481 -23.049,3.086 -15.078,3.246 -29.577,8.263 -43.649,14.104 -7.036,2.933 -13.967,6.091 -20.796,9.45 -6.848,3.377 -13.521,6.882 -20.216,10.794 l 3.911,-0.18 c -2.91,-1.353 -5.668,-2.492 -8.529,-3.631 -2.84,-1.127 -5.698,-2.189 -8.572,-3.203 -5.75,-2.024 -11.571,-3.835 -17.454,-5.435 -11.765,-3.193 -23.797,-5.532 -36.007,-6.688 -12.2,-1.146 -24.612,-1.089 -36.871,0.833 -12.236,1.908 -24.331,5.772 -35.23,12.003 -1.919,1.094 -2.587,3.537 -1.493,5.456 1.094,1.919 3.534,2.589 5.453,1.495 9.955,-5.663 21.078,-9.218 32.514,-10.979 11.45,-1.773 23.205,-1.82 34.858,-0.701 11.663,1.127 23.251,3.397 34.615,6.507 5.681,1.557 11.312,3.322 16.867,5.29 2.776,0.985 5.536,2.017 8.266,3.105 2.707,1.083 5.486,2.245 8.009,3.425 1.291,0.603 2.733,0.495 3.882,-0.163 l 0.029,-0.017 c 6.313,-3.677 12.989,-7.16 19.64,-10.452 6.679,-3.292 13.456,-6.384 20.316,-9.25 13.72,-5.709 27.808,-10.578 42.186,-13.679 7.184,-1.536 14.441,-2.613 21.668,-2.926 7.217,-0.318 14.423,0.176 21.199,1.921 6.747,1.694 13.055,4.97 18.733,9.175 5.66,4.249 10.681,9.442 15.031,15.178 8.662,11.524 14.846,25.058 18.326,39.136 1.736,7.041 2.765,14.253 2.856,21.411 0.073,7.134 -0.795,14.291 -3.268,20.638 -0.609,1.586 -1.328,3.108 -2.164,4.536 -0.824,1.437 -1.752,2.793 -2.811,4.009 -1.053,1.218 -2.189,2.353 -3.457,3.306 -1.219,0.923 -2.727,1.857 -4.22,2.674 -6.004,3.266 -12.773,4.813 -19.612,4.426 -6.843,-0.345 -13.665,-2.467 -20.034,-5.593 -3.188,-1.568 -6.278,-3.392 -9.238,-5.414 -1.48,-1.011 -2.928,-2.071 -4.333,-3.177 -0.703,-0.552 -1.395,-1.117 -2.07,-1.69 -0.658,-0.558 -1.374,-1.19 -1.903,-1.695 -1.626,-1.551 -4.202,-1.491 -5.753,0.136 -0.351,0.37 -0.627,0.804 -0.813,1.248 -0.956,2.304 -2.115,4.781 -3.275,7.142 -1.173,2.384 -2.404,4.745 -3.685,7.08 -2.562,4.67 -5.322,9.234 -8.271,13.662 -5.904,8.845 -12.56,17.189 -20.13,24.52 -7.552,7.324 -16.046,13.659 -25.413,18.071 -4.668,2.226 -9.564,3.926 -14.558,5.083 -4.921,1.118 -10.065,1.567 -15.25,1.469 C 110.334,42.995 99.854,40.918 89.628,38.001 79.379,35.09 69.295,31.357 59.427,27.077 39.729,18.435 20.673,8.019 2.17,-3.112 L 2.131,-3.136 C 1.232,-3.677 0.066,-3.387 -0.475,-2.488 -0.978,-1.653 -0.754,-0.58 0,0"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(573.377,313.4453)",
    id: "g766"
  }, /*#__PURE__*/React.createElement("path", {
    id: "path768",
    style: {
      fill: "none",
      stroke: "#2d2d2d",
      strokeWidth: 8,
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeMiterlimit: 10,
      strokeDasharray: "none",
      strokeOpacity: 1
    },
    d: "m 0,0 c 0,0 -44.045,-23.673 -52.033,-68.749 -7.988,-45.075 12.245,-84.405 12.245,-84.405"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(642.8447,236.7559)",
    id: "g770"
  }, /*#__PURE__*/React.createElement("path", {
    id: "path772",
    style: {
      fill: "#2d2d2d",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none"
    },
    d: "m 0,0 -4.775,-6.612 -2.368,-3.381 c -0.785,-1.133 -1.529,-2.285 -2.309,-3.422 -1.512,-2.301 -2.923,-4.652 -4.298,-7.038 -1.317,-2.425 -2.694,-4.744 -5.01,-7.063 l -0.009,-0.008 c -0.148,-0.15 -0.389,-0.15 -0.538,-10e-4 -0.048,0.048 -0.082,0.109 -0.098,0.171 -0.857,3.188 -0.371,6.259 0.531,9.082 0.899,2.834 1.987,5.606 3.245,8.282 0.626,1.339 1.276,2.67 1.997,3.955 0.689,1.306 1.433,2.578 2.214,3.828 0.768,1.259 1.589,2.481 2.44,3.687 0.866,1.217 1.727,2.352 2.765,3.56 1.442,1.676 3.967,1.866 5.643,0.426 C 1.015,4.104 1.271,1.77 0.074,0.104 Z"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(715.6172,220.2588)",
    id: "g774"
  }, /*#__PURE__*/React.createElement("path", {
    id: "path776",
    style: {
      fill: "#2d2d2d",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none"
    },
    d: "M 0,0 -0.229,0.819 C -0.32,1.123 -0.417,1.433 -0.523,1.74 -0.729,2.358 -0.964,2.974 -1.21,3.582 c -0.497,1.216 -1.07,2.397 -1.692,3.526 -1.245,2.264 -2.791,4.274 -4.575,5.838 -3.568,3.135 -8.175,4.131 -13.151,3.093 -2.471,-0.489 -4.975,-1.391 -7.411,-2.586 -0.639,-0.265 -1.181,-0.594 -1.74,-0.908 -0.555,-0.332 -1.14,-0.584 -1.668,-0.992 l -1.628,-1.123 c -0.536,-0.391 -1.042,-0.845 -1.568,-1.263 -1.067,-0.808 -2.013,-1.83 -3.025,-2.745 -0.943,-1.016 -1.927,-1.987 -2.824,-3.067 -0.905,-1.07 -1.829,-2.126 -2.675,-3.266 -0.883,-1.104 -1.712,-2.261 -2.531,-3.43 -3.293,-4.664 -6.19,-9.681 -8.906,-14.814 -2.709,-5.14 -5.187,-10.432 -7.496,-15.809 -4.581,-10.775 -8.82,-21.727 -13.456,-32.687 l -0.002,-0.005 c -0.072,-0.171 -0.269,-0.251 -0.44,-0.179 -0.141,0.06 -0.22,0.203 -0.203,0.348 0.68,5.957 1.971,11.783 3.471,17.554 1.547,5.756 3.34,11.454 5.471,17.038 4.236,11.169 9.034,22.234 15.707,32.504 3.359,5.11 7.096,10.108 11.968,14.335 2.345,2.153 5.189,4.037 8.098,5.538 2.843,1.456 5.926,2.646 9.247,3.364 3.301,0.719 6.926,0.919 10.489,0.096 3.568,-0.757 6.906,-2.564 9.579,-4.878 C 0.5,16.729 2.576,13.955 4.187,11.049 5.002,9.596 5.692,8.096 6.288,6.565 6.585,5.799 6.864,5.028 7.113,4.239 7.241,3.846 7.359,3.448 7.475,3.042 7.593,2.618 7.688,2.267 7.813,1.719 8.302,-0.434 6.953,-2.574 4.801,-3.063 2.716,-3.536 0.642,-2.285 0.069,-0.25 Z"
  }))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAstronoutSittingNotebook);
export default __webpack_public_path__ + "static/media/astronout-sitting-notebook.91384da84d8bd87edbcc47a2ddc5fd9a.svg";
export { ForwardRef as ReactComponent };